
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// 
// index.js
// Cacao
// 
// Created on 7/4/23
// 
var $27637818bf42bbb8$exports = {};
function $27637818bf42bbb8$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
$27637818bf42bbb8$var$$parcel$export($27637818bf42bbb8$exports, "Array", ()=>$27637818bf42bbb8$var$$24b828e2c0ac7de2$export$2e2bcd8739ae039);
$27637818bf42bbb8$var$$parcel$export($27637818bf42bbb8$exports, "assert", ()=>$27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97);
$27637818bf42bbb8$var$$parcel$export($27637818bf42bbb8$exports, "isEquivalent", ()=>$27637818bf42bbb8$var$$84c84b328e1b047d$export$2c3070a504066332);
$27637818bf42bbb8$var$$parcel$export($27637818bf42bbb8$exports, "pointee", ()=>$27637818bf42bbb8$var$$f6056fdcef89ff06$export$46838187e754e06c);
$27637818bf42bbb8$var$$parcel$export($27637818bf42bbb8$exports, "tree", ()=>$27637818bf42bbb8$var$$f6056fdcef89ff06$export$4767d4262788a6cc);
// 
// index.js
// Cacao
// 
// Created on 9/6/22
// 
// 
// Array.js
// Cacao
// 
// Created on 9/6/22
// 
// 
// Assertions.js
// Cacao
// 
// Created on 9/6/22
// 
function $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
class $27637818bf42bbb8$var$$24b828e2c0ac7de2$var$_Array extends Array {
    copy() {
        return this.slice(0);
    }
    append(element) {
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(element, "`element` is required.");
        this.push(element);
    }
    appendContentsOf(array) {
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(array, "`array` is required.");
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(Array.isArray(array), "`array` needs to be an Array.");
        this.push(...array);
    }
    insertAt(element, index) {
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(element, "`element` is required.");
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(index >= 0 && index <= this.count, "`index` is out of bounds.");
        this.splice(index, 0, element); // insert `element` at index `index`.
    }
    removeFirst(element) {
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(element, "`element` is required.");
        const index = this.indexOf(element);
        if (index != -1) return this.splice(index, 1)[0];
        return undefined;
    }
    removeLast() {
        const count = this.count;
        if (count > 0) return this.removeAt(count - 1);
        return undefined;
    }
    removeAt(index) {
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(index >= 0 && index < this.count, "`index` is out of bounds.");
        if (index != -1) return this.splice(index, 1)[0];
        return undefined;
    }
    removeAll(whereFn) {
        if (whereFn) {
            const elements = this.filter((element, index)=>!whereFn(element, index));
            this.length = 0;
            this.push(...elements);
        } else this.length = 0;
    }
    swapAt(fromIndex, toIndex) {
        const count = this.count;
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(fromIndex >= 0 && fromIndex < count, "`fromIndex` is out of bounds.");
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(toIndex >= 0 && toIndex < count, "`toIndex` is out of bounds.");
        if (fromIndex == toIndex) return;
        this.splice(toIndex, 0, this.splice(fromIndex, 1)[0]);
    }
    contains(element) {
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(element, "`element` is required.");
        return this.indexOf(element) != -1;
    }
    get isEmpty() {
        return this.length <= 0;
    }
    get first() {
        const count = this.count;
        if (count > 0) return this[0];
        return undefined;
    }
    get last() {
        const count = this.count;
        if (count > 0) return this[count - 1];
        return undefined;
    }
    get count() {
        return this.length;
    }
}
var $27637818bf42bbb8$var$$24b828e2c0ac7de2$export$2e2bcd8739ae039 = $27637818bf42bbb8$var$$24b828e2c0ac7de2$var$_Array;
// 
// Equivalence.js
// Cacao
// 
// Created on 9/6/22
// 
function $27637818bf42bbb8$var$$84c84b328e1b047d$export$2c3070a504066332(a, b) {
    if (a === b) return true;
    if (typeof a != "object" || typeof b != "object" || a == null || b == null) return false;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length != keysB.length) return false;
    for (let key of keysA){
        if (!keysB.includes(key)) return false;
        if (typeof a[key] === "function" || typeof b[key] === "function") {
            if (a[key].toString() != b[key].toString()) return false;
        } else {
            if (!$27637818bf42bbb8$var$$84c84b328e1b047d$export$2c3070a504066332(a[key], b[key])) return false;
        }
    }
    return true;
}
// 
// Logging.js
// Cacao
// 
// Created on 9/6/22
// 
function $27637818bf42bbb8$var$$f6056fdcef89ff06$export$46838187e754e06c(instance) {
    let pointee;
    try {
        pointee = instance.constructor?.name || instance.toString();
    } catch  {
        pointee = "[Unknown]";
    }
    return pointee;
}
function $27637818bf42bbb8$var$$f6056fdcef89ff06$export$4767d4262788a6cc(root, name, children) {
    return new $27637818bf42bbb8$var$$f6056fdcef89ff06$var$TreeGrapher(name, children).parse(root);
}
class $27637818bf42bbb8$var$$f6056fdcef89ff06$var$TreeGrapher {
    constructor(name, children, limit = 1000){
        this.settings = {
            keyword: {
                name: name,
                children: children
            },
            maxLevel: limit
        };
    }
    setPre(level, hasNext, parentPre = "") {
        return `${parentPre}${hasNext ? "\u251C" : "\u2514"}\u{2500}\u{2500} `;
    }
    setTransferPre(parentPre = "", hasNext) {
        return `${parentPre}${hasNext ? "\u2502" : " "}   `;
    }
    parse(tree, level = 0, parentPre = "", treeStr = "") {
        if (!this.check(tree, level)) return "";
        if (Array.isArray(tree)) tree.forEach((child, index)=>{
            const hasNext = tree[index + 1] ? true : false;
            const children = child[this.settings.keyword.children];
            treeStr += `${this.setPre(level, hasNext, parentPre)}${child[this.settings.keyword.name]}\n`;
            if (children) treeStr += this.parse(children, level + 1, this.setTransferPre(parentPre, hasNext));
        });
        else {
            const children = tree[this.settings.keyword.children];
            treeStr = `${tree[this.settings.keyword.name]}\n`;
            if (children) treeStr += this.parse(children, level + 1);
        }
        return treeStr;
    }
    check(tree, level) {
        if (typeof tree !== "object") return false;
        if (level >= this.settings.maxLevel) return false;
        return true;
    }
}


// 
// App.js
// Cacao
// 
// Created on 8/23/22
// 

class $1553bf3484a166d1$var$App {
    #document;
    #readyState;
    #documentHasFinishedLoading = false;
    constructor(document){
        (0, $27637818bf42bbb8$exports.assert)(document, "A container `document` is required to use App.");
        this.#document = document;
        this.#attach();
    }
    documentReadyStateDidChange(document) {
    // Override if needed.
    }
    documentDidLoad(document) {
    // Override if needed.
    }
    #attach() {
        const document = this.#document;
        const handleDocumentState = ()=>{
            if (this.#readyState != document.readyState) {
                this.#readyState = document.readyState;
                this.documentReadyStateDidChange(document);
            }
            switch(document.readyState){
                case "loaded":
                case "complete":
                case "interactive":
                    // The document has finished loading. We can now access the DOM elements.
                    if (!this.#documentHasFinishedLoading) {
                        this.#documentHasFinishedLoading = true;
                        this.documentDidLoad(document);
                    }
                    break;
            }
        };
        handleDocumentState();
        if (!this.#documentHasFinishedLoading) document.addEventListener("readystatechange", handleDocumentState);
    }
    get document() {
        return this.#document;
    }
}
var $1553bf3484a166d1$export$2e2bcd8739ae039 = $1553bf3484a166d1$var$App;


// 
// View.js
// Cacao
// 
// Created on 8/23/22
// 
// 
// index.js
// Cacao
// 
// Created on 9/6/22
// 
// 
// Array.js
// Cacao
// 
// Created on 9/6/22
// 
// 
// Assertions.js
// Cacao
// 
// Created on 9/6/22
// 
function $5868598d1aabdccb$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}


class $e59551ef346ff73a$var$_Array extends Array {
    copy() {
        return this.slice(0);
    }
    append(element) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(element, "`element` is required.");
        this.push(element);
    }
    appendContentsOf(array) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(array, "`array` is required.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(Array.isArray(array), "`array` needs to be an Array.");
        this.push(...array);
    }
    insertAt(element, index) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(element, "`element` is required.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(index >= 0 && index <= this.count, "`index` is out of bounds.");
        this.splice(index, 0, element); // insert `element` at index `index`.
    }
    removeFirst(element) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(element, "`element` is required.");
        const index = this.indexOf(element);
        if (index != -1) return this.splice(index, 1)[0];
        return undefined;
    }
    removeLast() {
        const count = this.count;
        if (count > 0) return this.removeAt(count - 1);
        return undefined;
    }
    removeAt(index) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(index >= 0 && index < this.count, "`index` is out of bounds.");
        if (index != -1) return this.splice(index, 1)[0];
        return undefined;
    }
    removeAll(whereFn) {
        if (whereFn) {
            const elements = this.filter((element, index)=>!whereFn(element, index));
            this.length = 0;
            this.push(...elements);
        } else this.length = 0;
    }
    swapAt(fromIndex, toIndex) {
        const count = this.count;
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(fromIndex >= 0 && fromIndex < count, "`fromIndex` is out of bounds.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(toIndex >= 0 && toIndex < count, "`toIndex` is out of bounds.");
        if (fromIndex == toIndex) return;
        this.splice(toIndex, 0, this.splice(fromIndex, 1)[0]);
    }
    contains(element) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(element, "`element` is required.");
        return this.indexOf(element) != -1;
    }
    get isEmpty() {
        return this.length <= 0;
    }
    get first() {
        const count = this.count;
        if (count > 0) return this[0];
        return undefined;
    }
    get last() {
        const count = this.count;
        if (count > 0) return this[count - 1];
        return undefined;
    }
    get count() {
        return this.length;
    }
}
var $e59551ef346ff73a$export$2e2bcd8739ae039 = $e59551ef346ff73a$var$_Array;



// 
// Equivalence.js
// Cacao
// 
// Created on 9/6/22
// 
function $a277ea0f99f667f4$export$2c3070a504066332(a, b) {
    if (a === b) return true;
    if (typeof a != "object" || typeof b != "object" || a == null || b == null) return false;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length != keysB.length) return false;
    for (let key of keysA){
        if (!keysB.includes(key)) return false;
        if (typeof a[key] === "function" || typeof b[key] === "function") {
            if (a[key].toString() != b[key].toString()) return false;
        } else {
            if (!$a277ea0f99f667f4$export$2c3070a504066332(a[key], b[key])) return false;
        }
    }
    return true;
}


// 
// Logging.js
// Cacao
// 
// Created on 9/6/22
// 
function $bade16267cea3bd0$export$46838187e754e06c(instance) {
    let pointee;
    try {
        pointee = instance.constructor?.name || instance.toString();
    } catch  {
        pointee = "[Unknown]";
    }
    return pointee;
}
function $bade16267cea3bd0$export$4767d4262788a6cc(root, name, children) {
    return new $bade16267cea3bd0$var$TreeGrapher(name, children).parse(root);
}
class $bade16267cea3bd0$var$TreeGrapher {
    constructor(name, children, limit = 1000){
        this.settings = {
            keyword: {
                name: name,
                children: children
            },
            maxLevel: limit
        };
    }
    setPre(level, hasNext, parentPre = "") {
        return `${parentPre}${hasNext ? "\u251C" : "\u2514"}\u{2500}\u{2500} `;
    }
    setTransferPre(parentPre = "", hasNext) {
        return `${parentPre}${hasNext ? "\u2502" : " "}   `;
    }
    parse(tree, level = 0, parentPre = "", treeStr = "") {
        if (!this.check(tree, level)) return "";
        if (Array.isArray(tree)) tree.forEach((child, index)=>{
            const hasNext = tree[index + 1] ? true : false;
            const children = child[this.settings.keyword.children];
            treeStr += `${this.setPre(level, hasNext, parentPre)}${child[this.settings.keyword.name]}\n`;
            if (children) treeStr += this.parse(children, level + 1, this.setTransferPre(parentPre, hasNext));
        });
        else {
            const children = tree[this.settings.keyword.children];
            treeStr = `${tree[this.settings.keyword.name]}\n`;
            if (children) treeStr += this.parse(children, level + 1);
        }
        return treeStr;
    }
    check(tree, level) {
        if (typeof tree !== "object") return false;
        if (level >= this.settings.maxLevel) return false;
        return true;
    }
}




class $75862b29e2b1753f$var$View {
    #node;
    #subviews = new (0, $e59551ef346ff73a$export$2e2bcd8739ae039)();
    #superview;
    #isNodeLoaded = false;
    constructor(){
    //
    }
    makeNode(document1) {
        return document1.createElement("div");
    }
    addSubview(subview1) {
        this.insertSubview(subview1, this.#subviews.length);
    }
    insertSubviewBelow(subview1, siblingSubview) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1 !== siblingSubview, `Attempted to insert subview "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" as a sibling that is the same view.`);
        this.insertSubview(subview1, this.#subviews.indexOf(siblingSubview));
    }
    insertSubviewAbove(subview1, siblingSubview) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1 !== siblingSubview, `Attempted to insert subview "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" as a sibling that is the same view.`);
        this.insertSubview(subview1, this.#subviews.indexOf(siblingSubview) + 1);
    }
    insertSubview(subview1, index) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1, `Attempted to insert undefined subview at index ${index}`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1 instanceof $75862b29e2b1753f$var$View, `Attempted to insert invalid subview "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" at index ${index}" that's not a View.`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1 != this, `Attempted to insert view "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" as a subview of itself.`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)((index)=>0, `Attempted to insert subview "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" at invalid index ${index}"`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(index != -1, "Index cannot be -1.");
        if (subview1.superview !== this) subview1.removeFromSuperview();
        try {
            const { node: node } = this;
            const { childNodes: childNodes } = node;
            if (index >= childNodes.length) node.appendChild(subview1.node);
            else node.insertBefore(subview1.node, childNodes[index].node);
        } catch (error) {
            throw new Error(`Couldn't perform DOM hierarchy change when inserting view "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}". Document may be in an inconsistent state.`, {
                cause: error
            });
        }
        this.#subviews.insertAt(subview1, index);
        subview1.#superview = this;
    }
    removeFromSuperview() {
        const { superview: superview } = this;
        if (superview) {
            superview.#removeSubview(this);
            return;
        }
        if (this.isNodeLoaded) {
            const { node: node } = this;
            const { parentNode: parentNode } = node;
            if (parentNode) parentNode.removeChild(node);
        }
    }
    isDescendantOfView(view) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(view, `The view to test against the receiver cannot be undefined.`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview instanceof $75862b29e2b1753f$var$View, `The view to test against the receiver "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview)}" is not a View.`);
        const visit = (viewToTest)=>{
            if (viewToTest == view) return true;
            const parent = viewToTest.superview;
            return parent ? visit(parent) : false;
        };
        return visit(this);
    }
    #removeSubview(subview1) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1, "Subview is required.");
        this.#subviews.removeFirst(subview1);
        if (subview1.isNodeLoaded) subview1.node.remove();
    }
    // Node
    makeNodeIfNeeded() {
        if (this.#isNodeLoaded) return;
        // TODO: Support passing custom `document` instance, shadow DOM?
        let node;
        try {
            node = this.makeNode(document);
        } catch  {
            throw new Error("A DOM node couldn't be materialized for this View.");
        }
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(node, "The result of -makeNode() must return a DOM node for this View.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(node instanceof Node, "A DOM node must be an instance of Node.");
        this.#node = node;
        this.#isNodeLoaded = true;
    }
    // Getters
    get isNodeLoaded() {
        return this.#isNodeLoaded;
    }
    get node() {
        this.makeNodeIfNeeded();
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(this.#node, "The node shouldn't be undefined at this point.");
        return this.#node;
    }
    get subviews() {
        return this.#subviews.copy();
    }
    get superview() {
        return this.#superview;
    }
}
var $75862b29e2b1753f$export$2e2bcd8739ae039 = $75862b29e2b1753f$var$View;


// 
// RootView.js
// Cacao
// 
// Created on 8/23/22
// 


class $7f8792a5bdbc7afc$var$RootView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    #container;
    constructor(container){
        super();
        (0, $27637818bf42bbb8$exports.assert)(container, "A `container` is required.");
        (0, $27637818bf42bbb8$exports.assert)(container instanceof HTMLElement, "`container` is not an HTMLElement.");
        this.#container = container;
        this.attach();
    }
    get container() {
        return this.#container;
    }
    attach() {
        try {
            this.#container.appendChild(this.node);
        } catch  {
            throw new Error(`Failed to connect RootView to container.`);
        }
    }
    detach() {
        const parent = this.node.parent;
        if (parent) parent.removeChild(this.node);
    }
}
var $7f8792a5bdbc7afc$export$2e2bcd8739ae039 = $7f8792a5bdbc7afc$var$RootView;


// 
// Canvas2DView.js
// Cacao
// 
// Created on 9/8/22
// 

var $ba5a447b6ce1696c$exports = {};
function $ba5a447b6ce1696c$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "Interpolation", ()=>$ba5a447b6ce1696c$var$$e3e2971203022b54$export$2e2bcd8739ae039);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "RubberBanding", ()=>$ba5a447b6ce1696c$var$$47bfed8c5aa73889$export$2e2bcd8739ae039);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "Rect", ()=>$ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "Size", ()=>$ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "Point", ()=>$ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "Edge", ()=>$ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$b9d9805c9b77a56d);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "EdgeInsets", ()=>$ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "Path2D", ()=>$ba5a447b6ce1696c$var$$e2b259e740dd748e$export$2e2bcd8739ae039);
// 
// index.js
// Cacao
// 
// Created on 7/4/23
// 
// 
// Geometry.js
// Cacao
// 
// Created on 9/8/22
// 
class $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d {
    origin = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a.zero;
    size = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec.zero;
    static make(x, y, width, height) {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d(new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a(x, y), new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec(width, height));
    }
    static from(rect) {
        if (!rect) return undefined;
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(rect.origin.x, rect.origin.y, rect.size.width, rect.size.height);
    }
    static get zero() {
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(0, 0, 0, 0);
    }
    static get null() {
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(Infinity, Infinity, 0, 0);
    }
    constructor(origin, size){
        this.origin = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a.from(origin);
        this.size = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec.from(size);
    }
    equals(rect) {
        rect = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(rect);
        return this.origin.x == rect.origin.x && this.origin.y == rect.origin.y && this.size.width == rect.size.width && this.size.height == rect.size.height;
    }
    copy() {
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(this.origin.x, this.origin.y, this.size.width, this.size.height);
    }
    offsetBy(dx, dy) {
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(this.origin.x + dx, this.origin.y + dy, this.size.width, this.size.height);
    }
    insetBy(dx, dy) {
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(this.origin.x + dx, this.origin.y + dy, this.size.width - 2 * dx, this.size.height - 2 * dy);
    }
    insetByEdgeInsets(edgeInsets) {
        edgeInsets = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a.from(edgeInsets);
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(this.origin.x + edgeInsets.left, this.origin.y + edgeInsets.top, this.size.width - edgeInsets.left - edgeInsets.right, this.size.height - edgeInsets.top - edgeInsets.bottom);
    }
    divide(slice, remainder, amount, edge) {
        slice.origin = this.origin.copy();
        slice.size = this.size.copy();
        remainder.origin = this.origin.copy();
        remainder.size = this.size.copy();
        switch(edge){
            case $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$b9d9805c9b77a56d.minX:
                slice.size.width = amount;
                remainder.origin.x += amount;
                remainder.size.width -= amount;
                break;
            case $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$b9d9805c9b77a56d.maxX:
                slice.origin.x = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(slice).maxX - amount;
                slice.size.width = amount;
                remainder.size.width -= amount;
                break;
            case $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$b9d9805c9b77a56d.minY:
                slice.size.height = amount;
                remainder.origin.y += amount;
                remainder.size.height -= amount;
                break;
            case $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$b9d9805c9b77a56d.maxY:
                slice.origin.y = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(slice).maxY - amount;
                slice.size.height = amount;
                remainder.size.height -= amount;
                break;
        }
    }
    containsPoint(aPoint) {
        return aPoint.x >= this.origin.x && aPoint.y >= this.origin.y && aPoint.x < this.maxX && aPoint.y < this.maxY;
    }
    containsRect(rect) {
        const union = this.union(rect);
        return this.equals(union);
    }
    intersects(rect) {
        const intersection = this.intersection(rect);
        return !intersection.isEmpty;
    }
    intersection(rect) {
        rect = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(rect);
        const intersection = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(Math.max(this.minX, rect.minX), Math.max(this.minY, rect.minY), 0, 0);
        intersection.size.width = Math.min(this.maxX, rect.maxX) - intersection.minX;
        intersection.size.height = Math.min(this.maxY, rect.maxY) - intersection.minY;
        return intersection.isEmpty ? $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.zero : intersection;
    }
    union(rect) {
        rect = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(rect);
        const thisIsNull = this.isNull, rectIsNull = !rect || rect.isNull;
        if (thisIsNull) return rectIsNull ? $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.null : rect;
        if (rectIsNull) return thisIsNull ? $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.null : this.copy();
        const minX = Math.min(this.minX, rect.minX), minY = Math.min(this.minY, rect.minY), maxX = Math.max(this.maxX, rect.maxX), maxY = Math.max(this.maxY, rect.maxY);
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(minX, minY, maxX - minX, maxY - minY);
    }
    get standarized() {
        const { width: width, height: height } = this;
        const standardized = this.copy();
        if (width < 0.0) {
            standardized.origin.x += width;
            standardized.size.width = -width;
        }
        if (height < 0.0) {
            standardized.origin.y += height;
            standardized.size.height = -height;
        }
        return standardized;
    }
    get integral() {
        const rect = this.standarized;
        const x = Math.floor(this.minX), y = Math.floor(this.minY);
        aRect.size.width = Math.ceil(this.maxX) - x;
        aRect.size.height = Math.ceil(this.maxY) - y;
        aRect.origin.x = x;
        aRect.origin.y = y;
        return aRect;
    }
    get width() {
        return this.size.width;
    }
    set width(width) {
        this.size.width = width;
    }
    get height() {
        return this.size.height;
    }
    set height(height) {
        this.size.height = height;
    }
    get x() {
        return this.origin.x;
    }
    set x(x) {
        this.origin.x = x;
    }
    get y() {
        return this.origin.y;
    }
    set y(y) {
        this.origin.y = y;
    }
    get maxX() {
        return this.origin.x + this.size.width;
    }
    get maxY() {
        return this.origin.y + this.size.height;
    }
    get midX() {
        return this.origin.x + this.size.width / 2.0;
    }
    get midY() {
        return this.origin.y + this.size.height / 2.0;
    }
    get minX() {
        return this.origin.x;
    }
    get minY() {
        return this.origin.y;
    }
    get isEmpty() {
        return this.size.width <= 0.0 || this.size.height <= 0.0 || this.origin.x === Infinity || this.origin.y === Infinity;
    }
    get isNull() {
        return this.origin.x === Infinity || this.origin.y === Infinity;
    }
    toString() {
        return `{${this.origin}, ${this.size}}`;
    }
}
class $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a {
    x = 0;
    y = 0;
    static get zero() {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a(0, 0);
    }
    static from(point) {
        return !point ? $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a.zero : $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a.make(point.x, point.y);
    }
    static make(x, y) {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a(x, y);
    }
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    equals(point) {
        return this.x == point.x && this.y == point.y;
    }
    copy() {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a(this.x, this.y);
    }
    toString() {
        return `{${this.x}, ${this.y}}`;
    }
}
class $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec {
    width = 0;
    height = 0;
    static get zero() {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec(0, 0);
    }
    static from(size) {
        return !size ? undefined : $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec.make(size.width, size.height);
    }
    static make(width, height) {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec(width, height);
    }
    constructor(width, height){
        this.width = width;
        this.height = height;
    }
    equals(size) {
        return this.width == size.width && this.height == size.height;
    }
    copy() {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec(this.width, this.height);
    }
    toString() {
        return `{${this.width}, ${this.height}}`;
    }
}
class $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$b9d9805c9b77a56d {
    static minX() {
        return 0;
    }
    static minY() {
        return 1;
    }
    static maxX() {
        return 2;
    }
    static maxY() {
        return 3;
    }
}
class $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a {
    top = 0;
    left = 0;
    bottom = 0;
    right = 0;
    static get zero() {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a(0, 0, 0, 0);
    }
    static from(edgeInsets) {
        return !edgeInsets ? undefined : $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a.make(edgeInsets.top, edgeInsets.left, edgeInsets.bottom, edgeInsets.right);
    }
    static make(top, left, bottom, right) {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a(top, left, bottom, right);
    }
    constructor(top = 0, left = 0, bottom = 0, right = 0){
        this.top = top;
        this.left = left;
        this.bottom = bottom;
        this.right = right;
    }
    equals(edgeInsets) {
        const { top: top, left: left, bottom: bottom, right: right } = this;
        return top == edgeInsets.top && left == edgeInsets.left && bottom == edgeInsets.bottom && right == edgeInsets.right;
    }
    copy() {
        const { top: top, left: left, bottom: bottom, right: right } = this;
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a(top, left, bottom, right);
    }
}
// 
// Interpolation.js
// Cacao
// 
// Created on 6/8/23
// 
function $ba5a447b6ce1696c$var$$e3e2971203022b54$var$lerp(x, y, a) {
    return x * (1 - a) + y * a;
}
function $ba5a447b6ce1696c$var$$e3e2971203022b54$var$clamp(a, min = 0, max = 1) {
    return Math.min(max, Math.max(min, a));
}
function $ba5a447b6ce1696c$var$$e3e2971203022b54$var$invlerp(a, b, value) {
    return (value - a) / (b - a);
}
function $ba5a447b6ce1696c$var$$e3e2971203022b54$var$range(x1, y1, x2, y2, a) {
    return $ba5a447b6ce1696c$var$$e3e2971203022b54$var$lerp(x2, y2, $ba5a447b6ce1696c$var$$e3e2971203022b54$var$invlerp(x1, y1, a));
}
var $ba5a447b6ce1696c$var$$e3e2971203022b54$export$2e2bcd8739ae039 = {
    lerp: $ba5a447b6ce1696c$var$$e3e2971203022b54$var$lerp,
    clamp: $ba5a447b6ce1696c$var$$e3e2971203022b54$var$clamp,
    range: $ba5a447b6ce1696c$var$$e3e2971203022b54$var$range,
    invlerp: $ba5a447b6ce1696c$var$$e3e2971203022b54$var$invlerp
};
// 
// RubberBanding.js
// Cacao
// 
// Created on 5/8/23
// 
function $ba5a447b6ce1696c$var$$47bfed8c5aa73889$var$clampedValueUsingRubberBandingParameters(value, parameters) {
    const { coeff: coeff = 0.55, dim: dim } = parameters;
    return (1.0 - 1.0 / (value * coeff / dim + 1.0)) * dim;
}
var $ba5a447b6ce1696c$var$$47bfed8c5aa73889$export$2e2bcd8739ae039 = {
    clamp: $ba5a447b6ce1696c$var$$47bfed8c5aa73889$var$clampedValueUsingRubberBandingParameters
};
// 
// Path2D.js
// Cacao
// 
// Created on 9/9/22
// 
class $ba5a447b6ce1696c$var$$e2b259e740dd748e$var$_Path2D extends Path2D {
    roundedRect(x, y, width, height, cornerRadius, roundedCornerStyle) {
        const rect = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(x, y, width, height);
        const { minX: minX, minY: minY, maxX: maxX, maxY: maxY } = rect;
        switch(roundedCornerStyle){
            case "continous":
                const limit = Math.min(width, height) / 2 / 1.52866483;
                const limitedRadius = Math.min(cornerRadius, limit);
                const TOP_LEFT = (x, y)=>{
                    return [
                        minX + x * limitedRadius,
                        minY + y * limitedRadius
                    ];
                };
                const TOP_RIGHT = (x, y)=>{
                    return [
                        maxX - x * limitedRadius,
                        minX + y * limitedRadius
                    ];
                };
                const BOTTOM_RIGHT = (x, y)=>{
                    return [
                        maxX - x * limitedRadius,
                        maxY - y * limitedRadius
                    ];
                };
                const BOTTOM_LEFT = (x, y)=>{
                    return [
                        minX + x * limitedRadius,
                        maxY - y * limitedRadius
                    ];
                };
                const { moveTo: moveTo, lineTo: lineTo, bezierCurveTo: bezierCurveTo } = this;
                moveTo.apply(this, TOP_LEFT(1.52866483, 0.00000000));
                lineTo.apply(this, TOP_RIGHT(1.52866471, 0.00000000));
                bezierCurveTo.apply(this, [].concat(TOP_RIGHT(1.08849323, 0.00000000), TOP_RIGHT(0.86840689, 0.00000000), TOP_RIGHT(0.66993427, 0.06549600)));
                lineTo.apply(this, TOP_RIGHT(0.63149399, 0.07491100));
                bezierCurveTo.apply(this, [].concat(TOP_RIGHT(0.37282392, 0.16905899), TOP_RIGHT(0.16906013, 0.37282401), TOP_RIGHT(0.07491176, 0.63149399)));
                bezierCurveTo.apply(this, [].concat(TOP_RIGHT(0.00000000, 0.86840701), TOP_RIGHT(0.00000000, 1.08849299), TOP_RIGHT(0.00000000, 1.52866483)));
                lineTo.apply(this, BOTTOM_RIGHT(0.00000000, 1.52866471));
                bezierCurveTo.apply(this, [].concat(BOTTOM_RIGHT(0.00000000, 1.08849323), BOTTOM_RIGHT(0.00000000, 0.86840689), BOTTOM_RIGHT(0.06549569, 0.66993493)));
                lineTo.apply(this, BOTTOM_RIGHT(0.07491111, 0.63149399));
                bezierCurveTo.apply(this, [].concat(BOTTOM_RIGHT(0.16905883, 0.37282392), BOTTOM_RIGHT(0.37282392, 0.16905883), BOTTOM_RIGHT(0.63149399, 0.07491111)));
                bezierCurveTo.apply(this, [].concat(BOTTOM_RIGHT(0.86840689, 0.00000000), BOTTOM_RIGHT(1.08849323, 0.00000000), BOTTOM_RIGHT(1.52866471, 0.00000000)));
                lineTo.apply(this, BOTTOM_LEFT(1.52866483, 0.00000000));
                bezierCurveTo.apply(this, [].concat(BOTTOM_LEFT(1.08849299, 0.00000000), BOTTOM_LEFT(0.86840701, 0.00000000), BOTTOM_LEFT(0.66993397, 0.06549569)));
                lineTo.apply(this, BOTTOM_LEFT(0.63149399, 0.07491111));
                bezierCurveTo.apply(this, [].concat(BOTTOM_LEFT(0.37282401, 0.16905883), BOTTOM_LEFT(0.16906001, 0.37282392), BOTTOM_LEFT(0.07491100, 0.63149399)));
                bezierCurveTo.apply(this, [].concat(BOTTOM_LEFT(0.00000000, 0.86840689), BOTTOM_LEFT(0.00000000, 1.08849323), BOTTOM_LEFT(0.00000000, 1.52866471)));
                lineTo.apply(this, TOP_LEFT(0.00000000, 1.52866483));
                bezierCurveTo.apply(this, [].concat(TOP_LEFT(0.00000000, 1.08849299), TOP_LEFT(0.00000000, 0.86840701), TOP_LEFT(0.06549600, 0.66993397)));
                lineTo.apply(this, TOP_LEFT(0.07491100, 0.63149399));
                bezierCurveTo.apply(this, [].concat(TOP_LEFT(0.16906001, 0.37282401), TOP_LEFT(0.37282401, 0.16906001), TOP_LEFT(0.63149399, 0.07491100)));
                bezierCurveTo.apply(this, [].concat(TOP_LEFT(0.86840701, 0.00000000), TOP_LEFT(1.08849299, 0.00000000), TOP_LEFT(1.52866483, 0.00000000)));
                break;
            default:
                if (width < 2 * cornerRadius) cornerRadius = width / 2;
                if (height < 2 * cornerRadius) cornerRadius = height / 2;
                this.moveTo(x + cornerRadius, minY);
                this.arcTo(maxX, minY, maxX, maxY, cornerRadius);
                this.arcTo(maxX, maxY, minX, maxY, cornerRadius);
                this.arcTo(minX, maxY, minX, minY, cornerRadius);
                this.arcTo(minX, minY, maxX, minY, cornerRadius);
                break;
        }
        this.closePath();
    }
}
var $ba5a447b6ce1696c$var$$e2b259e740dd748e$export$2e2bcd8739ae039 = $ba5a447b6ce1696c$var$$e2b259e740dd748e$var$_Path2D;



class $9d9c9f916c716294$var$Canvas2DView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    #options = {
        width: 1,
        height: 1,
        scale: 0
    };
    #dirtyRect;
    #displayRequestID;
    makeNode(document) {
        return document.createElement("canvas");
    }
    drawRect(rect) {
    // override to render
    }
    setNeedsDisplay() {
        this.#dirtyRect = (0, $ba5a447b6ce1696c$exports.Rect).null;
        this.#scheduleDisplay();
    }
    setNeedsDisplayInRect(rect) {
        (0, $27637818bf42bbb8$exports.assert)(rect, "A rect must be passed.");
        rect = (0, $ba5a447b6ce1696c$exports.Rect).from(rect);
        this.#dirtyRect = this.#dirtyRect?.union(rect) || rect;
        this.#scheduleDisplay();
    }
    #scheduleDisplay() {
        const view = this;
        if (this.#displayRequestID) return;
        this.#displayRequestID = window.requestAnimationFrame(function BROWSER_IS_CALLING_OUT_TO_CANVAS2DVIEW_REQUEST_ANIMATION_FRAME_CALLBACK() {
            view.#displayRequestID = undefined;
            view.#display();
        });
    }
    #display() {
        const { node: node, options: options, context: context } = this;
        const { width: width, height: height, scale: scale } = options;
        const bounds = (0, $ba5a447b6ce1696c$exports.Rect).make(0, 0, width, height);
        // Scale context:
        const scaled = scale != 1;
        if (scaled) {
            context.save();
            context.scale(scale, scale);
        }
        // Calculate dirty rect. If rect is null, refresh the entire bounds of the canvas:
        let dirtyRect = this.#dirtyRect?.copy();
        if (!dirtyRect || dirtyRect.isNull) dirtyRect = bounds;
        // Intersect so we don't draw outside of bounds:
        dirtyRect = bounds.intersection(dirtyRect);
        // Clear entire bounds if `dirtyRect` is actually the whole view.
        // Maybe this should be a property.
        if (dirtyRect.equals(bounds)) context.clearRect(0, 0, width, height);
        // Call drawRect():
        this.drawRect(dirtyRect);
        // Restore context:
        if (scaled) context.restore();
        this.#dirtyRect = undefined;
    }
    set options(options) {
        let { width: width, height: height, scale: scale } = options;
        (0, $27637818bf42bbb8$exports.assert)(width && height, "`width` and `height` are required options.");
        if (!scale || scale <= 0.01) scale = window.devicePixelRatio;
        this.#options = {
            width: width,
            height: height,
            scale: scale
        };
        const { node: node } = this;
        node.width = width * scale;
        node.height = height * scale;
        node.style.width = `${width}px`;
        node.style.height = `${height}px`;
        this.setNeedsDisplay();
    }
    get options() {
        const { width: width, height: height, scale: scale } = this.#options;
        return {
            width: width,
            height: height,
            scale: scale
        };
    }
    get context() {
        return this.node.getContext("2d");
    }
}
var $9d9c9f916c716294$export$2e2bcd8739ae039 = $9d9c9f916c716294$var$Canvas2DView;


// 
// index.js
// Cacao
// 
// Created on 7/6/23
// 
// 
// GestureRecognizer.js
// Cacao
// 
// Created on 6/2/23
// 
// 
// Touch.js
// Cacao
// 
// Created on 5/8/23
// 
class $7a418fcf08526eb7$var$Touch {
    constructor(){
        this.x = 0;
        this.y = 0;
        this.tapCount = 0;
    }
}
var $7a418fcf08526eb7$export$2e2bcd8739ae039 = $7a418fcf08526eb7$var$Touch;


// 
// TouchType.js
// Cacao
// 
// Created on 6/17/23
// 
class $f83981078758ac76$var$TouchType {
    static direct = 0;
    static indirect = 1;
    static pen = 2;
}
var $f83981078758ac76$export$2e2bcd8739ae039 = $f83981078758ac76$var$TouchType;


// 
// GestureRecognizerState.js
// Cacao
// 
// Created on 6/2/23
// 
class $0d409e98add6de65$var$GestureRecognizerState {
    static possible = 0;
    static began = 1;
    static changed = 2;
    static ended = 3;
    static cancelled = 4;
    static failed = 5;
    static recognized = $0d409e98add6de65$var$GestureRecognizerState.ended;
}
var $0d409e98add6de65$export$2e2bcd8739ae039 = $0d409e98add6de65$var$GestureRecognizerState;


class $d835ab54782b41e2$var$GestureRecognizer {
    enabled;
    didChange;
    shouldBegin;
    constructor(){
        this._state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible;
        this._touches = [];
        this.enabled = true;
    }
    reset() {
        this._state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible;
        this._event = undefined;
    }
    set state(state) {
        if (this.shouldBegin && this._state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible && (state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).recognized || state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began)) {
            if (!this.shouldBegin(this)) state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).failed;
        }
        const allowedStateTransitions = [
            // Discrete gestures:
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).recognized,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).failed,
                false
            ],
            // Continuous gestures:
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).began,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).began,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).began,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).began,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended,
                true
            ]
        ];
        let transition;
        for (const [fromState, toState, notify] of allowedStateTransitions)if (fromState == this._state && toState == state) {
            transition = {
                fromState: fromState,
                toState: toState,
                notify: notify
            };
            break;
        }
        if (!transition) throw new Error(`GestureRecognizer: Invalid state transition from ${this._state} to ${state}.`);
        if (transition) {
            this._state = state;
            if (transition.notify && this.didChange) this.didChange(this);
        }
    }
    get state() {
        return this._state;
    }
    get event() {
        return this._event;
    }
    began(touches, event) {
    //
    }
    moved(touches, event) {
    //
    }
    ended(touches, event) {
    //
    }
    cancelled(touches, event) {
    //
    }
    handleEvent(event) {
        // For now, only single-touch (and mouse) events are supported:
        if (!event.isPrimary) return;
        this._event = event;
        const touch = new (0, $7a418fcf08526eb7$export$2e2bcd8739ae039)();
        touch.identifier = event.pointerId;
        touch.x = event.clientX;
        touch.y = event.clientY;
        touch.tapCount = 1; // TODO
        if (event.pointerType) switch(event.pointerType){
            case "mouse":
                touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).indirect;
                break;
            case "pen":
                touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).pen;
                break;
            case "touch":
                touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).direct;
                break;
            default:
                touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).indirect;
                break;
        }
        else touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).indirect;
        if (event.type == "pointerdown") {
            const continueTrackingOnWindow = true; // Expose this behavior?
            const target = continueTrackingOnWindow ? window : event.currentTarget;
            target.addEventListener("pointermove", this);
            target.addEventListener("pointerup", this);
            target.addEventListener("pointercancel", this);
            this._currentTarget = target;
        }
        const touches = [
            touch
        ];
        this._touches = touches;
        // Deliver touches if the gesture has not yet failed.
        if (this.state != (0, $0d409e98add6de65$export$2e2bcd8739ae039).failed) switch(event.type){
            case "pointerdown":
                this.began(touches, event);
                break;
            case "pointermove":
                this.moved(touches, event);
                break;
            case "pointerup":
                this.ended(touches, event);
                break;
            case "pointercancel":
                this.cancelled(touches, event);
                break;
        }
        switch(event.type){
            case "pointerup":
            case "pointercancel":
                const target = this._currentTarget;
                target.removeEventListener("pointermove", this);
                target.removeEventListener("pointerup", this);
                target.removeEventListener("pointercancel", this);
                this.reset();
                break;
        }
    }
    attach(target) {
        target.addEventListener("pointerdown", this);
    }
    locationInView(view) {
        // TODO: Convert to view coordinates.
        const touch = this._touches[0];
        if (touch) {
            const { x: x, y: y } = touch;
            return {
                x: x,
                y: y
            };
        }
        return undefined;
    }
    touchesInView(view) {
        // TODO: Return touches for the view.
        return this._touches.slice(0);
    }
    canPreventGestureRecognizer(preventingGestureRecognizer) {
        return true;
    }
    canBePreventedByGestureRecognizer(preventedGestureRecognizer) {
        return true;
    }
}
var $d835ab54782b41e2$export$2e2bcd8739ae039 = $d835ab54782b41e2$var$GestureRecognizer;



// 
// PanGestureRecognizer.js
// Cacao
// 
// Created on 5/8/23
// 


class $e0ae29d71a91a327$var$PanGestureRecognizer extends (0, $d835ab54782b41e2$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._touchesSamplingQueue = [];
    }
    set translation(value) {
        this._initialTouchPosition = value;
        this._latestTouchPosition = value;
    }
    get translation() {
        let x = 0, y = 0;
        const initial = this._initialTouchPosition, latest = this._latestTouchPosition;
        if (initial && latest) {
            x = latest.x - initial.x;
            y = latest.y - initial.y;
        }
        return {
            x: x,
            y: y
        };
    }
    get velocity() {
        this.dequeueSampledTouchesBeforeInterval(1000);
        const queue = this._touchesSamplingQueue;
        if (queue.length < 2) return {
            x: 0,
            y: 0
        };
        const first = queue[0], last = queue[queue.length - 1];
        const distance = {
            x: last.position.x - first.position.x,
            y: last.position.y - first.position.y
        };
        const time = (last.time - first.time) / 1000;
        return {
            x: distance.x / time,
            y: distance.y / time
        };
    }
    // - Sampling touches
    addSampleForTouchPosition(position) {
        this._touchesSamplingQueue.push({
            position: position,
            time: Date.now()
        });
        this.dequeueSampledTouchesBeforeInterval(50);
    }
    dequeueSampledTouchesBeforeInterval(duration) {
        const queue = this._touchesSamplingQueue;
        const expiration = Date.now() - duration;
        while(queue.length && queue[0].time < expiration)queue.shift();
    }
    updateLatestTouchPosition(position, event) {
        position = {
            x: position.x,
            y: position.y
        };
        this._latestTouchPosition = position;
        this.addSampleForTouchPosition(position);
    }
    // - State overrides
    reset() {
        super.reset();
        this._latestTouchPosition = undefined;
        this._initialTouchPosition = undefined;
        this._touchesSamplingQueue.splice(0);
    }
    began(touches, event) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible) {
            this._initialTouchPosition = {
                x: touches[0].x,
                y: touches[0].y
            };
            this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).began;
        }
    }
    moved(touches, event) {
        this.updateLatestTouchPosition(touches[0], event);
        this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed;
    }
    ended(touches, event) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) {
            this.updateLatestTouchPosition(touches[0], event);
            this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended;
        }
    }
    cancelled(touches, event) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled;
    }
}
var $e0ae29d71a91a327$export$2e2bcd8739ae039 = $e0ae29d71a91a327$var$PanGestureRecognizer;


// 
// TapGestureRecognizer.js
// Cacao
// 
// Created on 6/8/23
// 


class $890fe1ec12e520f9$var$TapGestureRecognizer extends (0, $d835ab54782b41e2$export$2e2bcd8739ae039) {
    numberOfTapsRequired = 1;
    numberOfTouchesRequired = 1;
    canPreventGestureRecognizer(preventingGestureRecognizer) {
        if (preventingGestureRecognizer instanceof $890fe1ec12e520f9$var$TapGestureRecognizer) return preventingGestureRecognizer.numberOfTapsRequired > this.numberOfTapsRequired;
        else return super.canPreventGestureRecognizer(preventingGestureRecognizer);
    }
    canBePreventedByGestureRecognizer(preventedGestureRecognizer) {
        if (preventedGestureRecognizer instanceof $890fe1ec12e520f9$var$TapGestureRecognizer) return preventedGestureRecognizer.numberOfTapsRequired <= this.numberOfTapsRequired;
        else return super.canBePreventedByGestureRecognizer(preventedGestureRecognizer);
    }
    began(touches) {
        const touch = touches[0];
        if (touch.tapCount >= this.numberOfTapsRequired) {
            if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).began;
            else if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed;
        }
    }
    moved(touches) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled;
    }
    ended(touches) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended;
    }
    cancelled(touches) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled;
    }
}
var $890fe1ec12e520f9$export$2e2bcd8739ae039 = $890fe1ec12e520f9$var$TapGestureRecognizer;






// 
// index.js
// Cacao
// 
// Created on 7/6/23
// 
// 
// AnimatedProperty.js
// Cacao
// 
// Created on 5/8/23
// 
class $ff409bc474e7092d$var$AnimatedProperty {
    constructor(key, fromValue, toValue, timing){
        if (!key) throw "AnimatedProperty: Cannot animate a property without a key.";
        const f = this.parseValue(fromValue), t = this.parseValue(toValue);
        if (!t.unit) t.unit = f.unit; // assume `fromValue` unit if not present.
        if (!(!f.unit && !t.unit || f.unit === t.unit)) throw `AnimatedProperty: Unit for values mismatch. Animating from "${f.unit}" to "${t.unit}" is not supported.`;
        this.fromValue = f.floatValue;
        this.toValue = t.floatValue;
        this.unit = f.unit;
        this.key = key;
        this.timing = timing;
    }
    parseValue(value) {
        let floatValue = 0.0, unit = undefined;
        if (typeof value === "string" || value instanceof String) {
            floatValue = parseFloat(value);
            unit = value.match(/[\d.\-\+]*\s*(.*)/)[1] || "";
        } else if (!isNaN(value)) floatValue = value;
        return {
            unit: unit,
            floatValue: floatValue
        };
    }
    get reversed() {
        return new $ff409bc474e7092d$var$AnimatedProperty(this.key, this.toValue, this.fromValue, this.timing);
    }
}
var $ff409bc474e7092d$export$2e2bcd8739ae039 = $ff409bc474e7092d$var$AnimatedProperty;


// 
// PropertyAnimator.js
// Cacao
// 
// Created on 5/4/23
// 


// 
// SpringTimingParameters.js
// Cacao
// 
// Created on 5/8/23
// 
const { sqrt: $eb4fc4a00fc6fb7d$var$sqrt, exp: $eb4fc4a00fc6fb7d$var$exp, cos: $eb4fc4a00fc6fb7d$var$cos, sin: $eb4fc4a00fc6fb7d$var$sin, cosh: $eb4fc4a00fc6fb7d$var$cosh, sinh: $eb4fc4a00fc6fb7d$var$sinh } = Math;
class $eb4fc4a00fc6fb7d$var$SpringTimingParameters {
    constructor(options = {}){
        const { damping: damping = 10, mass: mass = 1, stiffness: stiffness = 100, initialVelocity: initialVelocity = {
            dx: 0,
            dy: 0
        } } = options;
        this.damping = damping;
        this.mass = mass;
        this.stiffness = stiffness;
        this.initialVelocity = initialVelocity;
    }
    copy() {
        const { damping: damping, mass: mass, stiffness: stiffness, initialVelocity: initialVelocity } = this;
        return new $eb4fc4a00fc6fb7d$var$SpringTimingParameters({
            damping: damping,
            mass: mass,
            stiffness: stiffness,
            initialVelocity: initialVelocity
        });
    }
    copyTimingFunction(options = {}) {
        const { damping: b, mass: m, stiffness: k } = this;
        const v0 = this.#initialVelocityForVelocityAxis(options.velocityAxis);
        return (t)=>{
            const beta = b / (2.0 * m);
            const omega0 = $eb4fc4a00fc6fb7d$var$sqrt(k / m);
            const omega1 = $eb4fc4a00fc6fb7d$var$sqrt(omega0 * omega0 - beta * beta);
            const omega2 = $eb4fc4a00fc6fb7d$var$sqrt(beta * beta - omega0 * omega0);
            const x0 = -1;
            const envelope = $eb4fc4a00fc6fb7d$var$exp(-beta * t);
            let fraction;
            if (beta < omega0) fraction = -x0 + envelope * (x0 * $eb4fc4a00fc6fb7d$var$cos(omega1 * t) + (beta * x0 + v0) / omega1 * $eb4fc4a00fc6fb7d$var$sin(omega1 * t));
            else if (beta == omega0) fraction = -x0 + envelope * (x0 + (beta * x0 + v0) * t);
            else fraction = -x0 + envelope * (x0 * $eb4fc4a00fc6fb7d$var$cosh(omega2 * t) + (beta * x0 + v0) / omega2 * $eb4fc4a00fc6fb7d$var$sinh(omega2 * t));
            return fraction;
        };
    }
    #initialVelocityForVelocityAxis(axis) {
        switch(axis){
            case $eb4fc4a00fc6fb7d$var$SpringTimingParameters.VelocityAxis.x:
                return this.initialVelocity.dx;
            case $eb4fc4a00fc6fb7d$var$SpringTimingParameters.VelocityAxis.y:
                return this.initialVelocity.dy;
            default:
                return 0;
        }
    }
    static get VelocityAxis() {
        return {
            x: 1,
            y: 2
        };
    }
}
var $eb4fc4a00fc6fb7d$export$2e2bcd8739ae039 = $eb4fc4a00fc6fb7d$var$SpringTimingParameters;


// 
// TimingCurve.js
// Cacao
// 
// Created on 5/8/23
// 
const $78e7515453ca2290$export$45db2fc2f15997e7 = (t)=>{
    return t;
};
const $78e7515453ca2290$export$2d59ca22077f6eab = (t)=>{
    return t * t;
};
const $78e7515453ca2290$export$be35423d31ba201e = (t)=>{
    return t * (2 - t);
};
const $78e7515453ca2290$export$42add3d9cb3645a2 = (t)=>{
    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
const $78e7515453ca2290$export$5da70c9577229d30 = (t)=>{
    return t * t * t;
};
const $78e7515453ca2290$export$1157fb72e7fbceb5 = (t)=>{
    return --t * t * t + 1;
};
const $78e7515453ca2290$export$24656b269d8df7d6 = (t)=>{
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
const $78e7515453ca2290$export$c3d8280971f5e7ab = (t)=>{
    return t * t * t * t;
};
const $78e7515453ca2290$export$fb9e4320a4025f10 = (t)=>{
    return 1 - --t * t * t * t;
};
const $78e7515453ca2290$export$bd93209e120f4915 = (t)=>{
    return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
const $78e7515453ca2290$export$d5a2637b851d40fa = (t)=>{
    return t * t * t * t * t;
};
const $78e7515453ca2290$export$54ef52175ef1a966 = (t)=>{
    return 1 + --t * t * t * t * t;
};
const $78e7515453ca2290$export$40df750f1044ce5e = (t)=>{
    return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};


class $1c98d5f0dd1e30db$var$PropertyAnimator {
    constructor(options = {}){
        const { autoreverses: autoreverses = true, repeatCount: repeatCount = 0, interruptAnimationEvents: interruptAnimationEvents = [] } = options;
        if (options.timingParameters) this.timing = options.timingParameters.copy();
        else if (options.timingCurve) this.timing = {
            copyTimingFunction: ()=>options.timingCurve
        };
        else this.timing = {
            copyTimingFunction: ()=>$78e7515453ca2290$export$24656b269d8df7d6
        };
        this.autoreverses = autoreverses;
        this.repeatCount = repeatCount;
        this.interruptAnimationEvents = [
            "mousewheel",
            "touchstart"
        ] + interruptAnimationEvents;
    }
    animate(target, to, duration, completion) {
        if (!target) throw "PropertyAnimator: Cannot instantiate an animator without a target.";
        if (this.animating) this.stopAnimation();
        let properties1;
        const createAnimationForKey = (key, flags)=>{
            const fromValue = target[key], toValue = to[key];
            if (fromValue != toValue) {
                const timing = this.timing.copyTimingFunction(flags);
                return new (0, $ff409bc474e7092d$export$2e2bcd8739ae039)(key, fromValue, toValue, timing);
            }
            return undefined;
        };
        const { x: x, y: y } = (0, $eb4fc4a00fc6fb7d$export$2e2bcd8739ae039).VelocityAxis;
        if (to instanceof (0, $ba5a447b6ce1696c$exports.Point)) properties1 = [
            createAnimationForKey("x", {
                velocityAxis: x
            }),
            createAnimationForKey("y", {
                velocityAxis: y
            })
        ].filter(Boolean);
        else if (to instanceof (0, $ba5a447b6ce1696c$exports.Size)) properties1 = [
            createAnimationForKey("width", {
                velocityAxis: x
            }),
            createAnimationForKey("height", {
                velocityAxis: y
            })
        ].filter(Boolean);
        else if (to instanceof (0, $ba5a447b6ce1696c$exports.Rect)) properties1 = [
            createAnimationForKey("origin.x", {
                velocityAxis: x
            }),
            createAnimationForKey("origin.y", {
                velocityAxis: y
            }),
            createAnimationForKey("size.width", {
                velocityAxis: x
            }),
            createAnimationForKey("size.height", {
                velocityAxis: y
            })
        ].filter(Boolean);
        else {
            properties1 = [];
            for(const key in to){
                const property = createAnimationForKey(key);
                if (property) properties1.push(property);
            }
        }
        this.target = target;
        this.duration = Math.max(duration, 0.1);
        this.beginTime = 0.0;
        this.properties = properties1;
        this.completion = completion;
        this.completed = false;
        this.startAnimation();
    }
    update() {
        if (this.beginTime == 0.0) this.beginTime = new Date().getTime();
        else {
            let deltaTime = new Date().getTime() - this.beginTime;
            let progress = deltaTime / this.duration;
            let target = this.target;
            this.updateTarget(progress);
        }
    }
    updateTarget(progress) {
        const target = this.target;
        function out(value, unit) {
            if (unit) value = String(value) + unit;
            return value;
        }
        function set(object, keyPath, value) {
            let components = keyPath.split("."), componentsCount = components.length;
            if (componentsCount > 1) {
                let count = componentsCount - 1;
                for(let idx = 0; idx < count; idx += 1)object = object[components[idx]];
            }
            let lastPathComponent = componentsCount > 0 ? components[componentsCount - 1] : keyPath;
            object[lastPathComponent] = value;
            return object;
        }
        if (progress < 1.0) {
            if (1 - progress < 0.001) {
                for (const property of this.properties)set(target, property.key, out(property.toValue, property.unit));
                this.complete();
            } else for (const property of this.properties){
                const percent = property.timing(progress);
                const value = property.fromValue + (property.toValue - property.fromValue) * percent;
                set(target, property.key, out(value, property.unit));
            }
        } else {
            for (const property of this.properties)set(target, property.key, out(property.toValue, property.unit));
            this.complete();
        }
    }
    complete() {
        let iteration = this.iterationCount + 1;
        let completed = iteration > this.repeatCount;
        if (!completed) {
            this.beginTime = 0.0;
            if (this.autoreverses) {
                const reversed = [];
                for (const property of properties)reversed.push(property.reversed);
                this.properties = reversed;
            } else this.updateTarget(0.0) // Manually update target to initial value.
            ;
        }
        this.iterationCount = iteration;
        if (completed) {
            this.completed = true;
            this.stopAnimation();
        }
    }
    stopAnimation() {
        if (!this.animating) return;
        this.animating = false;
        let targetScrollEventHandler = this.targetScrollEventHandler;
        if (targetScrollEventHandler) this.target.removeEventListener(targetScrollEventHandler);
        let request = this.frameRequest;
        if (request) cancelAnimationFrame(request);
        let completion = this.completion;
        if (completion) completion(this.completed);
        this.completion = undefined;
    }
    startAnimation() {
        if (this.animating) return;
        this.animating = true;
        this.iterationCount = 0;
        const targetScrollEventHandler = this.stopAnimation.bind(this);
        // if (this.target.addEventListener) {
        //   for (const name of this.interruptAnimationEvents) {
        //     this.target.addEventListener(name, targetScrollEventHandler)
        //   }
        // }
        const update = this.update.bind(this);
        const animate = ()=>{
            update();
            schedule();
            if (this.animating) {
                const { didAnimate: didAnimate } = this;
                if (didAnimate) didAnimate();
            }
        };
        const schedule = ()=>{
            if (this.animating) this.frameRequest = requestAnimationFrame(animate, this);
        };
        schedule();
    }
}
var $1c98d5f0dd1e30db$export$2e2bcd8739ae039 = $1c98d5f0dd1e30db$var$PropertyAnimator;








// 
// RootView.js
// portfolio
// 
// Created on 6/17/23
// 

// 
// TimelineView.js
// portfolio
// 
// Created on 5/7/23
// 


// 
// ScrollEngine.js
// portfolio
// 
// Created on 5/29/23
// 


// 
// ScrollEngineDecelerationRate.js
// portfolio
// 
// Created on 6/20/23
// 
class $fbb01217bb9c9331$var$ScrollEngineDecelerationRate {
    // UIScrollViewDecelerationRateNormal
    static normal = 0.998;
    // UIScrollViewDecelerationRateFast
    static fast = 0.99;
}
var $fbb01217bb9c9331$export$2e2bcd8739ae039 = $fbb01217bb9c9331$var$ScrollEngineDecelerationRate;


class $ac4c9aa809454a83$var$LockedDirection {
    static none = 0;
    static horizontal = 1;
    static vertical = 2;
}
class $ac4c9aa809454a83$var$ScrollEngine {
    _contentOffset = (0, $ba5a447b6ce1696c$exports.Point).zero;
    _contentSize = (0, $ba5a447b6ce1696c$exports.Size).zero;
    _contentInset = (0, $ba5a447b6ce1696c$exports.EdgeInsets).zero;
    _boundsSize = (0, $ba5a447b6ce1696c$exports.Size).zero;
    _lockedDirection = $ac4c9aa809454a83$var$LockedDirection.none;
    decelerationRate = (0, $fbb01217bb9c9331$export$2e2bcd8739ae039).normal;
    directionalLockEnabled = true;
    delegate;
    _anchorLimits = [];
    initialPosition = (0, $ba5a447b6ce1696c$exports.Point).zero;
    currentPosition = (0, $ba5a447b6ce1696c$exports.Point).zero;
    animator;
    get contentInset() {
        return this._contentInset.copy();
    }
    set contentInset(contentInset) {
        this._contentInset = (0, $ba5a447b6ce1696c$exports.EdgeInsets).from(contentInset);
    }
    get boundsSize() {
        return this._boundsSize.copy();
    }
    set boundsSize(size) {
        this._boundsSize = (0, $ba5a447b6ce1696c$exports.Size).from(size);
    }
    get contentOffset() {
        return this._contentOffset.copy();
    }
    set contentOffset(offset) {
        this._contentOffset = (0, $ba5a447b6ce1696c$exports.Point).from(offset);
    }
    get contentSize() {
        return this._contentSize.copy();
    }
    set contentSize(size) {
        this._contentSize = (0, $ba5a447b6ce1696c$exports.Size).from(size);
    }
    setContentOffset(contentOffset, animated) {
        if (animated) ;
        else this.contentOffset = contentOffset;
    }
    set anchorLimits(limits) {
        if (!limits) limits = [];
        this._anchorLimits = limits.map((limit)=>(0, $ba5a447b6ce1696c$exports.Point).from(limit));
    }
    get anchorLimits() {
        return this._anchorLimits.map((limit)=>(0, $ba5a447b6ce1696c$exports.Point).from(limit));
    }
    stop() {
        if (this.animator) this.animator.stopAnimation();
        this.delegate = undefined;
    }
    startDragging() {
        this._initialContentOffset = this.contentOffset;
        this.stop();
    }
    continueDragging(dx, dy) {
        const proposedOffset = {
            x: this._initialContentOffset.x + dx,
            y: this._initialContentOffset.y + dy
        };
        let offset = this.clampedContentOffset(proposedOffset);
        if (this.directionalLockEnabled) {
            if (this._lockedDirection == $ac4c9aa809454a83$var$LockedDirection.none) this._lockedDirection = this._determineLockedDirection({
                x: dx,
                y: dy
            });
            offset = this._restrictedContentOffset(offset);
        }
        this.contentOffset = offset;
    }
    _restrictedContentOffset(offset) {
        offset = (0, $ba5a447b6ce1696c$exports.Point).from(offset);
        switch(this._lockedDirection){
            case $ac4c9aa809454a83$var$LockedDirection.vertical:
                offset.x = this._initialContentOffset.x;
                break;
            case $ac4c9aa809454a83$var$LockedDirection.horizontal:
                offset.y = this._initialContentOffset.y;
                break;
            case $ac4c9aa809454a83$var$LockedDirection.none:
                break;
        }
        return offset;
    }
    _determineLockedDirection(translation) {
        const horizontalThreshold = 5;
        const verticalThreshold = 5;
        const absX = Math.abs(translation.x);
        const absY = Math.abs(translation.y);
        if (absX > horizontalThreshold && absX > absY) return $ac4c9aa809454a83$var$LockedDirection.horizontal;
        else if (absY > verticalThreshold && absY > absX) return $ac4c9aa809454a83$var$LockedDirection.vertical;
        return $ac4c9aa809454a83$var$LockedDirection.none;
    }
    endDragging(parameters, delegate) {
        this.delegate = delegate;
        const { decelerationVelocity: decelerationVelocity = {
            x: 0,
            y: 0
        } } = parameters;
        if (this.anchorLimits.length > 0) return this.moveOriginToTheNearestAnchor({
            decelerationVelocity: decelerationVelocity
        });
        else {
            const decelerationRate = this.decelerationRate;
            const projection = {
                x: this.contentOffset.x + $ac4c9aa809454a83$var$project(decelerationVelocity.x / 1000, decelerationRate),
                y: this.contentOffset.y + $ac4c9aa809454a83$var$project(decelerationVelocity.y / 1000, decelerationRate)
            };
            let clampedTarget = this._confinedContentOffset(projection);
            if (this.directionalLockEnabled) clampedTarget = this._restrictedContentOffset(clampedTarget);
            return this.animateOriginTo(clampedTarget, {
                decelerationVelocity: decelerationVelocity
            });
        }
    }
    // -
    _confinedContentOffset(contentOffset) {
        contentOffset = (0, $ba5a447b6ce1696c$exports.Point).make(contentOffset.x * -1, contentOffset.y * -1);
        const { contentSize: contentSize, boundsSize: boundsSize, contentInset: contentInset } = this;
        const bounds = new (0, $ba5a447b6ce1696c$exports.Rect)(this._contentOffset, boundsSize);
        const scrollerBounds = bounds.insetByEdgeInsets(contentInset);
        if (contentSize.width - contentOffset.x < scrollerBounds.width) contentOffset.x = contentSize.width - scrollerBounds.width;
        if (contentSize.height - contentOffset.y < scrollerBounds.size.height) contentOffset.y = contentSize.height - scrollerBounds.size.height;
        contentOffset.x = Math.max(contentOffset.x, 0);
        contentOffset.y = Math.max(contentOffset.y, 0);
        if (contentSize.width <= scrollerBounds.size.width) contentOffset.x = 0;
        if (contentSize.height <= scrollerBounds.size.height) contentOffset.y = 0;
        return (0, $ba5a447b6ce1696c$exports.Point).make(-contentOffset.x, -contentOffset.y);
    }
    // -
    projectionForDragging(parameters) {
        const { decelerationVelocity: decelerationVelocity } = parameters;
        const decelerationRate = this.decelerationRate;
        const projection = {
            x: this.contentOffset.x + $ac4c9aa809454a83$var$project(decelerationVelocity.x / 1000, decelerationRate),
            y: this.contentOffset.y + $ac4c9aa809454a83$var$project(decelerationVelocity.y / 1000, decelerationRate)
        };
        return projection;
    }
    nearestAnchorForDragging(parameters) {
        const projection = this.projectionForDragging(parameters);
        let origin = projection;
        if (this.directionalLockEnabled) origin = this._restrictedContentOffset(origin);
        return this.selectNearestAnchorToOrigin(origin);
    }
    moveOriginToTheNearestAnchor(parameters) {
        const projectionAnchor = this.nearestAnchorForDragging(parameters);
        return this.animateOriginTo(projectionAnchor, parameters);
    }
    selectNearestAnchorToOrigin(origin) {
        let minimumDistance = Infinity;
        let closestPosition;
        const calculateDistance = (a, b)=>{
            const differential = {
                x: b.x - a.x,
                y: b.y - a.y
            };
            const { x: x, y: y } = differential;
            const hypotenuse = Math.sqrt(x * x + y * y);
            return hypotenuse;
        };
        for (const anchor of this._anchorLimits){
            const distance = calculateDistance(anchor, origin);
            if (distance < minimumDistance) {
                closestPosition = anchor;
                minimumDistance = distance;
            }
        }
        return closestPosition;
    }
    animateOriginTo(origin, parameters) {
        const { decelerationVelocity: decelerationVelocity } = parameters;
        const initialPosition = this.contentOffset;
        const finalPosition = (0, $ba5a447b6ce1696c$exports.Point).from(origin);
        if (initialPosition.x == finalPosition.x && initialPosition.y == finalPosition.y) return false;
        const animationVelocity = $ac4c9aa809454a83$var$calculateInitialAnimationVelocity(decelerationVelocity, initialPosition, finalPosition);
        if (this.directionalLockEnabled) switch(this._lockedDirection){
            case $ac4c9aa809454a83$var$LockedDirection.horizontal:
                animationVelocity.dy = 0;
                break;
            case $ac4c9aa809454a83$var$LockedDirection.vertical:
                animationVelocity.dx = 0;
                break;
        }
        const duration = 800;
        const options = {
            timingParameters: new (0, $eb4fc4a00fc6fb7d$export$2e2bcd8739ae039)({
                damping: 18,
                initialVelocity: animationVelocity
            })
        };
        const position = initialPosition.copy();
        const animator = new (0, $1c98d5f0dd1e30db$export$2e2bcd8739ae039)(options);
        animator.didAnimate = ()=>{
            this.setContentOffset(position);
            const { delegate: delegate } = this;
            if (delegate) delegate.didAnimate();
        };
        if (this.delegate) this.delegate.willAnimate(finalPosition);
        animator.animate(position, finalPosition, duration, (completed)=>{
            if (completed) this._lockedDirection = $ac4c9aa809454a83$var$LockedDirection.none;
            const { delegate: delegate } = this;
            if (delegate) delegate.didFinish(completed);
        });
        this.animator = animator;
        return true;
    }
    clampedContentOffset(contentOffset) {
        const clampedTarget = (target, lowerBound, upperBound, boundsDimension)=>{
            if (target > lowerBound) {
                const diff = target - lowerBound;
                const dim = Math.abs(boundsDimension - lowerBound);
                return lowerBound + (0, $ba5a447b6ce1696c$exports.RubberBanding).clamp(diff, {
                    dim: dim
                });
            } else if (target < upperBound) {
                const diff = upperBound - target;
                const dim = Math.abs(boundsDimension - upperBound);
                return upperBound - (0, $ba5a447b6ce1696c$exports.RubberBanding).clamp(diff, {
                    dim: dim
                });
            } else return target;
        };
        const { contentSize: contentSize, boundsSize: boundsSize } = this;
        const maxX = -contentSize.width + boundsSize.width;
        const maxY = -contentSize.height + boundsSize.height;
        const offset = (0, $ba5a447b6ce1696c$exports.Point).make(clampedTarget(contentOffset.x, 0, maxX, boundsSize.width), clampedTarget(contentOffset.y, 0, maxY, boundsSize.height));
        return offset;
    }
}
function $ac4c9aa809454a83$var$project(initialVelocity, decelerationRate) {
    if (decelerationRate >= 1) throw "decelerationRate must be greater than one.";
    return initialVelocity * decelerationRate / (1 - decelerationRate);
}
// https://developer.apple.com/documentation/uikit/uispringtimingparameters/1649909-initialvelocity
function $ac4c9aa809454a83$var$calculateInitialAnimationVelocity(gestureVelocity, currentPosition, finalPosition) {
    let animationVelocity = {
        dx: 0,
        dy: 0
    };
    let xDistance = finalPosition.x - currentPosition.x;
    let yDistance = finalPosition.y - currentPosition.y;
    if (xDistance != 0) animationVelocity.dx = gestureVelocity.x / xDistance;
    if (yDistance != 0) animationVelocity.dy = gestureVelocity.y / yDistance;
    return animationVelocity;
}
var $ac4c9aa809454a83$export$2e2bcd8739ae039 = $ac4c9aa809454a83$var$ScrollEngine;


// 
// TimelineViewCell.js
// portfolio
// 
// Created on 5/7/23
// 

// 
// CaptionView.js
// portfolio
// 
// Created on 6/1/23
// 

class $5451dd8d7fbc9cbe$var$CaptionView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    configure(item) {
        const { title: title, role: role, company: company, year: year, team: team, action: action } = item;
        this.node.innerHTML = `
    <div class="caption-wrapper">
      <header>
        <hgroup>
          <h1>${title}</h2>
          <h2>${role}</h2>
          ${company ? `<h2>${company}</h2>` : ""}
        </hgroup>
        
        <time>${year}</time>
        
        ${action ? `<a href="${action.url}" class="action" target="_blank">${action.title}</a>` : ""}
      </header>
      
      ${team && team.length > 0 ? `<aside class="team">
        ${team.map((name)=>`<p>${name}</p>`).join("")}
      </aside>` : ""}
    </div>
    `;
    }
    static #measureView = new $5451dd8d7fbc9cbe$var$CaptionView();
    static #measureViewContainer = document.createElement("div");
    static calculateMinimumHeightForItem(item, fittingWidth = 0) {
        const view = $5451dd8d7fbc9cbe$var$CaptionView.#measureView;
        view.configure(item);
        const containerNode = $5451dd8d7fbc9cbe$var$CaptionView.#measureViewContainer;
        containerNode.setAttribute("style", `position: absolute; top: 0; left: 0; width: ${fittingWidth}px; visibility: hidden;`);
        containerNode.appendChild(view.node);
        document.body.appendChild(containerNode);
        const calculatedHeight = Math.ceil(view.node.offsetHeight);
        containerNode.parentNode.removeChild(containerNode);
        return calculatedHeight;
    }
}
var $5451dd8d7fbc9cbe$export$2e2bcd8739ae039 = $5451dd8d7fbc9cbe$var$CaptionView;


class $2a5d9fbe61164be2$var$TimelineViewCell extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    delegate;
    attributes;
    pictureNode;
    captionView;
    constructor(delegate){
        super();
        this.delegate = delegate;
        const { node: node } = this;
        const { style: nodeStyle } = node;
        nodeStyle.top = "0";
        nodeStyle.left = "0";
        nodeStyle.transformOrigin = "0 0";
        const pictureNode = document.createElement("button");
        pictureNode.className = "picture";
        pictureNode.addEventListener("click", this);
        node.appendChild(pictureNode);
        const captionView = new (0, $5451dd8d7fbc9cbe$export$2e2bcd8739ae039)();
        captionView.node.className = "caption";
        node.appendChild(captionView.node);
        this.pictureNode = pictureNode;
        this.captionView = captionView;
    }
    makeNode(document1) {
        return document1.createElement("article");
    }
    configure(configuration) {
        const { attributes: attributes, data: data, options: options } = configuration;
        const { node: node, pictureNode: pictureNode, captionView: captionView } = this;
        const { frame: frame, frameForImage: frameForImage, frameForCaption: frameForCaption, alphaForCaption: alphaForCaption, transform: transform } = attributes;
        const px = "px";
        const { style: nodeStyle } = node;
        nodeStyle.width = frame.width + px;
        nodeStyle.height = frame.height + px;
        nodeStyle.transform = new DOMMatrix().translate(frame.x, frame.y).multiply(transform);
        const { style: pictureStyle } = pictureNode;
        pictureStyle.top = frameForImage.y + px;
        pictureStyle.left = frameForImage.x + px;
        pictureStyle.width = frameForImage.width + px;
        pictureStyle.height = frameForImage.height + px;
        const { style: captionStyle } = captionView.node;
        captionStyle.top = frameForCaption.y + px;
        captionStyle.left = frameForCaption.x + px;
        captionStyle.width = frameForCaption.width + px;
        captionStyle.height = frameForCaption.height + px;
        const isCaptionHidden = alphaForCaption == 0.0;
        captionStyle.display = isCaptionHidden ? "none" : ""; // "" is a reset.
        captionStyle.opacity = alphaForCaption;
        if (this.data != data) {
            this.data = data;
            // Setup caption:
            captionView.configure(data);
            // Setup image:
            const { image: image } = data;
            pictureNode.ariaLabel = image.alt;
            pictureNode.innerHTML = `
        <picture>
          <source srcset="${image.dark.webp}" type="image/webp" media="(prefers-color-scheme: dark)" />
          <source srcset="${image.webp}" type="image/webp" />
          
          <img src="${image.src}" alt="${image.alt}">
        </picture>
      `;
        }
        if (options) {
            const { selectable: selectable } = options;
            pictureNode.role = selectable ? "button" : "img";
            if (selectable) pictureNode.removeAttribute("tabIndex");
            else pictureNode.tabIndex = "-1";
        }
        this.attributes = attributes;
        this.selectable = options.selectable || false;
    }
    handleEvent(event) {
        if (event.target !== this.pictureNode) return;
        switch(event.type){
            case "click":
                this.pictureNode.blur();
                if (this.selectable) this.delegate.didSelectTimelineCellForItem(this, this.attributes.itemIndex);
                break;
        }
    }
}
var $2a5d9fbe61164be2$export$2e2bcd8739ae039 = $2a5d9fbe61164be2$var$TimelineViewCell;


// 
// TimelineInteractionCompletion.js
// portfolio
// 
// Created on 6/9/23
// 
class $c6f67cca1625e9fd$var$TimelineInteractionCompletion {
    type;
    parameters;
    constructor(type, parameters){
        this.type = type;
        this.parameters = parameters;
    }
    static decelerate({ decelerationVelocity: decelerationVelocity = Point.zero, animated: animated = false } = {}) {
        return new this(this.type.decelerate, {
            decelerationVelocity: decelerationVelocity,
            animated: animated
        });
    }
    static cancel({ animated: animated = false } = {}) {
        return new this(this.type.cancel, {
            animated: animated
        });
    }
    static focus({ animated: animated = false } = {}) {
        return new this(this.type.focus, {
            animated: animated
        });
    }
    static unfocus({ animated: animated = false } = {}) {
        return new this(this.type.unfocus, {
            animated: animated
        });
    }
    static get type() {
        return {
            decelerate: 1,
            focus: 2,
            unfocus: 3,
            cancel: 4
        };
    }
}
var $c6f67cca1625e9fd$export$2e2bcd8739ae039 = $c6f67cca1625e9fd$var$TimelineInteractionCompletion;



// 
// SnapRulerView.js
// portfolio
// 
// Created on 6/19/23
// 

class $8acc754ba5bba723$var$SnapRulerView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    _stops = [];
    _nodes = [];
    _enabled = false;
    constructor(){
        super();
        this.node.className = "snap-ruler";
        this.configure();
    }
    configure() {
        const { stops: stops, enabled: enabled, node: node } = this;
        if (this._invalidateStops) {
            if (stops.length > 0) {
                this._nodes = [];
                const fragment = document.createDocumentFragment();
                stops.forEach((stop, index)=>{
                    const element = document.createElement("div");
                    element.className = "snap-ruler-stop";
                    const { style: elementStyle } = element;
                    elementStyle.position = "absolute";
                    elementStyle.width = "1px";
                    elementStyle.height = "1px";
                    elementStyle.display = "block";
                    elementStyle.top = `${stop}px`;
                    elementStyle.left = "0px";
                    elementStyle.scrollSnapAlign = "start";
                    elementStyle.scrollSnapStop = "always";
                    this._nodes[index] = element;
                    fragment.appendChild(element);
                });
                node.innerHTML = "";
                node.appendChild(fragment);
            } else node.innerHTML = "";
        }
        const { style: nodeStyle } = node;
        nodeStyle.position = "absolute";
        nodeStyle.display = enabled ? "block" : "none";
        nodeStyle.pointerEvents = "none";
    }
    set stops(stops) {
        if (stops !== this._stops) {
            const canUpdate = stops.length == this._stops.length;
            this._stops = stops;
            if (canUpdate) stops.forEach((stop, index)=>{
                const element = this._nodes[index];
                element.style.top = `${stop}px`;
            });
            else {
                this._invalidateStops = true;
                this.configure();
                this._invalidateStops = false;
            }
        }
    }
    get stops() {
        return this._stops.slice(0);
    }
    set enabled(enabled) {
        if (this._enabled != enabled) {
            this._enabled = enabled;
            this.configure();
        }
    }
    get enabled() {
        return this._enabled;
    }
}
var $8acc754ba5bba723$export$2e2bcd8739ae039 = $8acc754ba5bba723$var$SnapRulerView;


// 
// Layout.js
// portfolio
// 
// Created on 5/27/23
// 

const { lerp: $b745121b735e32e1$var$lerp, invlerp: $b745121b735e32e1$var$invlerp, clamp: $b745121b735e32e1$var$clamp } = (0, $ba5a447b6ce1696c$exports.Interpolation);
class $b745121b735e32e1$export$d9dcde6be12ede2c {
    static right = 1;
    static anchorToBottom = 2;
}
class $b745121b735e32e1$export$41d5aec8582771fb {
    static regular = 1;
    static compressed = 2;
}
class $b745121b735e32e1$export$5bd8911201c95c6f {
    // A Size for the regular presentation for images.
    maximumRegularImageSize;
    // A Number for the caption width, shown on regular presentation.
    minimumCaptionWidth;
    // A Number for the spacing between image and caption.
    captionSpacing;
    // A CaptionPositionMode determining how to position the caption
    captionPositioningMode;
    // A EdgeInsets value determining spacing for the layout
    contentInset;
    // A Size for the compressed presentation for images.
    maximumCompressedImageSize;
    // A Number for spacing the images at minimum, used on compressed presentation.
    minimumInterSpacing;
    // A Size for the current bounds, that will determine the full-screen size for each page on regular presentation.
    boundsSize;
}
class $b745121b735e32e1$var$LayoutAttributes {
    // The index for the represented item.
    itemIndex;
    // A Rect to frame the item.
    frame;
    // A Rect to frame the image.
    frameForImage;
    // A Rect to frame the caption.
    frameForCaption;
    // A Number for the alpha for the caption.
    alphaForCaption;
    // A transform matrix.
    transform;
    constructor(itemIndex){
        this.itemIndex = itemIndex;
    }
    copy() {
        const copy = new $b745121b735e32e1$var$LayoutAttributes();
        copy.itemIndex = this.itemIndex;
        copy.frame = (0, $ba5a447b6ce1696c$exports.Rect).from(this.frame);
        copy.frameForImage = (0, $ba5a447b6ce1696c$exports.Rect).from(this.frameForImage);
        copy.frameForCaption = (0, $ba5a447b6ce1696c$exports.Rect).from(this.frameForCaption);
        copy.alphaForCaption = this.alphaForCaption;
        copy.transform = DOMMatrix.fromMatrix(this.transform);
        return copy;
    }
}
class $b745121b735e32e1$var$TimelineLayoutInteractiveTransition {
    origin;
    translation;
    focusedIndex;
    targetMode;
    minimumTranslationForMovement;
    transitioning;
    constructor(layout){
        this.layout = layout;
        this.translation = (0, $ba5a447b6ce1696c$exports.Point).zero;
    }
    updateInteractiveMovement(parameters) {
        const { translation: translation = {
            x: 0,
            y: 0
        } } = parameters;
        this.translation = translation;
        if (!this.didMoveEnough) {
            const { minimumTranslationForMovement: minimum } = this;
            if (minimum > 0) {
                const passed = Math.abs(translation.x) > minimum && !(Math.abs(translation.y) > minimum);
                if (!passed) this.translation = {
                    x: 0,
                    y: 0
                };
                else {
                    this.didMoveEnough = true;
                    this.origin = {
                        x: this.origin.x + translation.x,
                        y: this.origin.y + translation.y
                    };
                    this.translationDiff = {
                        x: translation.x,
                        y: translation.y
                    };
                    this.translation = {
                        x: 0,
                        y: 0
                    };
                }
            } else {
                this.didMoveEnough = true;
                this.translationDiff = (0, $ba5a447b6ce1696c$exports.Point).zero;
            }
            if (this.didMoveEnough) {
                const { interactionHasMovement: interactionHasMovement } = this;
                if (interactionHasMovement) interactionHasMovement();
            }
        } else {
            const i = this.translationDiff;
            this.translation = {
                x: translation.x - i.x,
                y: translation.y - i.y
            };
        }
    }
    setTransitionProgress({ x: x, y: y } = (0, $ba5a447b6ce1696c$exports.Point).zero, parameters) {
        const { focusedItemOrigin: focusedItemOrigin = {
            x: 0,
            y: 0
        }, translation: translation = {
            x: 0,
            y: 0
        }, targetOffset: targetOffset = {
            x: 0,
            y: 0
        } } = parameters;
        this.transitioning = {
            progressVector: {
                x: x,
                y: y
            },
            focusedItemOrigin: focusedItemOrigin,
            translation: translation,
            targetOffset: targetOffset
        };
    }
    complete(finished) {
        this.layout._interactiveTransition = undefined;
        if (finished) this.layout._mode = this.targetMode;
    }
}
class $b745121b735e32e1$var$TimelineLayoutInvalidation {
    static get all() {
        const invalidation = new $b745121b735e32e1$var$TimelineLayoutInvalidation();
        invalidation.calculateRegularAttributes = true;
        return invalidation;
    }
    // The regular attributes need to be recalculated.
    calculateRegularAttributes = false;
}
class $b745121b735e32e1$export$17b51a93bf0e48ea {
    // A TimelineLayoutOptions value with the options for configuring the layout.
    _options;
    // A TimelineLayoutDelegate object that provides layout info.
    delegate;
    // The current transition object.
    _interactiveTransition;
    // The current mode.
    _mode;
    // Returns a TimelineLayoutMode that represents the current mode.
    get currentMode() {
        return this._mode;
    }
    // Returns an array of LayoutItems that represent the layout.
    get layoutAttributes() {
        return this._layoutAttributes;
    }
    // Returns a Size for fitting the content.
    get contentSize() {
        return (0, $ba5a447b6ce1696c$exports.Size).from(this._contentSize);
    }
    contentSizeForMode(mode) {
        if (mode == $b745121b735e32e1$export$41d5aec8582771fb.regular) return this._regularContentSize;
        else if (mode == $b745121b735e32e1$export$41d5aec8582771fb.compressed) return this._compressedContentSize;
        else return (0, $ba5a447b6ce1696c$exports.Size).zero;
    }
    finalLayoutAttributesForItem(itemIndex, mode) {
        if (!mode) mode = this._mode;
        if (mode == $b745121b735e32e1$export$41d5aec8582771fb.regular) return this._regularLayoutAttributes[itemIndex];
        else if (mode == $b745121b735e32e1$export$41d5aec8582771fb.compressed) return this._compressedLayoutAttributes[itemIndex];
        else return undefined;
    }
    constructor(options, delegate){
        this._options = options;
        this._mode = $b745121b735e32e1$export$41d5aec8582771fb.compressed;
        this._invalidation = $b745121b735e32e1$var$TimelineLayoutInvalidation.all;
        this.delegate = delegate;
    }
    set options(options) {
        this._options = options;
        this._invalidation = $b745121b735e32e1$var$TimelineLayoutInvalidation.all;
    }
    get options() {
        return this._options;
    }
    // Begins a transition starting on the specified Point
    beginInteractiveTransition(origin, { minimumTranslationForMovement: minimumTranslationForMovement = 0 } = {}) {
        if (this._interactiveTransition) throw new Error("An interactive transition is in place.");
        const transition = new $b745121b735e32e1$var$TimelineLayoutInteractiveTransition(this);
        transition.minimumTranslationForMovement = minimumTranslationForMovement;
        transition.targetMode = this._mode == $b745121b735e32e1$export$41d5aec8582771fb.regular ? $b745121b735e32e1$export$41d5aec8582771fb.compressed : $b745121b735e32e1$export$41d5aec8582771fb.regular;
        transition.origin = origin;
        transition.focusedIndex = this.layoutAttributes.length > 0 ? 0 : null;
        const currentLayoutAttributes = this.layoutAttributes, count = currentLayoutAttributes.length;
        for(let idx = 0; idx < count; idx += 1){
            const attributes = currentLayoutAttributes[count - idx - 1];
            if (origin.y > attributes.frame.minY) {
                transition.focusedIndex = attributes.itemIndex;
                break;
            }
        }
        this._interactiveTransition = transition;
        return transition;
    }
    // Begins a transition from the specified item:
    beginInteractiveTransitionCenteredOnItem(item) {
        const { frame: frame } = this.layoutAttributes[item];
        const center = (0, $ba5a447b6ce1696c$exports.Point).make(frame.midX, frame.midY);
        const transition = this.beginInteractiveTransition(center);
        transition.focusedIndex = item;
        return transition;
    }
    cancelInteractiveTransition() {
        if (this._interactiveTransition) this._interactiveTransition.complete(false);
    }
    // Performs the layout.
    layout() {
        const { _invalidation: invalidation } = this;
        if (invalidation.calculateRegularAttributes) {
            this._calculateRegularAttributes();
            this._calculateCompressedAttributes();
            invalidation.calculateRegularAttributes = false;
        }
        this._layoutAttributes = this._regularLayoutAttributes;
        this._contentSize = this._regularContentSize;
        if (this._interactiveTransition) {
            if (this._interactiveTransition.transitioning) {
                this._layoutForInteractionCompletion();
                this._contentSize = this.contentSizeForMode(this._interactiveTransition.targetMode);
            } else this._layoutForInteraction();
        } else if (this._mode == $b745121b735e32e1$export$41d5aec8582771fb.compressed) {
            this._layoutAttributes = this._compressedLayoutAttributes;
            this._contentSize = this._compressedContentSize;
        }
    }
    _calculateRegularAttributes() {
        const layoutAttributes = [];
        const { options: options, delegate: delegate } = this;
        const bounds = (0, $ba5a447b6ce1696c$exports.Rect).make(0, 0, options.boundsSize.width, options.boundsSize.height);
        const contentRect = bounds.insetByEdgeInsets(options.contentInset);
        const { numberOfItems: numberOfItems } = delegate;
        let offsetY = 0.0;
        for(let item = 0; item < numberOfItems; item += 1){
            const maximumImageSize = (0, $ba5a447b6ce1696c$exports.Size).from(options.maximumRegularImageSize);
            maximumImageSize.height = Math.min(maximumImageSize.height, contentRect.height);
            const captionSize = (0, $ba5a447b6ce1696c$exports.Size).make(options.minimumCaptionWidth, 0);
            const captionReducesImageHeight = options.captionPositioningMode == $b745121b735e32e1$export$d9dcde6be12ede2c.anchorToBottom;
            if (captionReducesImageHeight) {
                captionSize.width = contentRect.width;
                captionSize.height = this.delegate.captionHeightForItem(item, captionSize.width);
                const height = contentRect.height - captionSize.height - options.captionSpacing;
                if (height < maximumImageSize.height) maximumImageSize.height = height;
            }
            const imageSize = delegate.imageSizeForItem(item);
            const scaleX = maximumImageSize.width / imageSize.width;
            const scaleY = maximumImageSize.height / imageSize.height;
            const imageScale = Math.min(scaleX, scaleY);
            const scaledImageSize = (0, $ba5a447b6ce1696c$exports.Size).make(Math.floor(imageSize.width * imageScale), Math.floor(imageSize.height * imageScale));
            const imageRect = new (0, $ba5a447b6ce1696c$exports.Rect)((0, $ba5a447b6ce1696c$exports.Point).zero, scaledImageSize);
            const captionRect = new (0, $ba5a447b6ce1696c$exports.Rect)((0, $ba5a447b6ce1696c$exports.Point).zero, captionSize);
            let itemSize;
            if (options.captionPositioningMode == $b745121b735e32e1$export$d9dcde6be12ede2c.right) {
                captionRect.origin.x = imageRect.maxX + options.captionSpacing;
                captionRect.size.height = imageRect.height;
                itemSize = (0, $ba5a447b6ce1696c$exports.Size).make(captionRect.maxX, imageRect.height);
            } else if (options.captionPositioningMode == $b745121b735e32e1$export$d9dcde6be12ede2c.anchorToBottom) {
                imageRect.origin.x = Math.round(contentRect.width / 2.0) - Math.round(imageRect.width / 2.0);
                imageRect.origin.y = Math.round((contentRect.height - captionSize.height - options.captionSpacing) / 2.0) - Math.round(imageRect.height / 2.0);
                captionRect.origin.y = contentRect.height - captionSize.height;
                itemSize = (0, $ba5a447b6ce1696c$exports.Size).from(contentRect.size);
            }
            const origin = (0, $ba5a447b6ce1696c$exports.Point).zero;
            origin.x = Math.min(contentRect.midX - Math.round(itemSize.width / 2.0), contentRect.maxX - itemSize.width);
            origin.y = offsetY + contentRect.midY - Math.round(itemSize.height / 2.0);
            const attributes = new $b745121b735e32e1$var$LayoutAttributes(item);
            attributes.frame = new (0, $ba5a447b6ce1696c$exports.Rect)(origin, itemSize);
            attributes.frameForImage = imageRect;
            attributes.frameForCaption = captionRect;
            attributes.alphaForCaption = 1.0;
            attributes.transform = new DOMMatrix();
            layoutAttributes.push(attributes);
            offsetY += bounds.height;
        }
        this._regularLayoutAttributes = layoutAttributes;
        this._regularContentSize = (0, $ba5a447b6ce1696c$exports.Size).make(bounds.width, Math.ceil(offsetY));
    }
    _calculateCompressedAttributes() {
        const { options: options } = this;
        const bounds = (0, $ba5a447b6ce1696c$exports.Rect).make(0, 0, options.boundsSize.width, options.boundsSize.height);
        const contentRect = bounds.insetByEdgeInsets(options.contentInset);
        const maximum = options.maximumRegularImageSize;
        const minimum = options.maximumCompressedImageSize;
        const preferedWidthToFillContentRect = contentRect.width * 0.45;
        const minifiedWidth = Math.max(minimum.width, preferedWidthToFillContentRect);
        const minificationScale = minifiedWidth / maximum.width;
        const interSpacing = Math.max(options.minimumInterSpacing, minifiedWidth / 5);
        const scaledCaptionWidth = options.captionPositioningMode == $b745121b735e32e1$export$d9dcde6be12ede2c.right ? (options.minimumCaptionWidth + options.captionSpacing) * minificationScale : 0.0;
        const scaledHeightForItems = this._regularLayoutAttributes.map((attributes)=>attributes.frameForImage.height * minificationScale).reduce((a, c)=>a + c, interSpacing * (this._regularLayoutAttributes.length - 1));
        let offsetY = contentRect.minY;
        if (contentRect.height > scaledHeightForItems) offsetY = contentRect.minY + Math.round(contentRect.height - scaledHeightForItems) / 2.0;
        const largestScaledImageWidth = this._regularLayoutAttributes.reduce((r, b)=>Math.max(r, b.frameForImage.width), Number.NEGATIVE_INFINITY) * minificationScale;
        const alignmentOriginX = contentRect.maxX - Math.round(largestScaledImageWidth * 0.5);
        this._compressedLayoutAttributesScale = minificationScale;
        this._compressedLayoutAttributes = this._regularLayoutAttributes.map((attributes)=>{
            const isLastItem = attributes === this._regularLayoutAttributes.at(-1);
            attributes = attributes.copy();
            const adjustedFrame = attributes.frame.copy();
            const size = adjustedFrame.size;
            const scaledSize = (0, $ba5a447b6ce1696c$exports.Size).make(size.width * minificationScale, size.height * minificationScale);
            adjustedFrame.origin.x = alignmentOriginX - Math.round((scaledSize.width - scaledCaptionWidth) * 0.5);
            adjustedFrame.origin.y = offsetY - attributes.frameForImage.minY * minificationScale;
            attributes.frame = adjustedFrame;
            attributes.transform = new DOMMatrix().scale(minificationScale);
            attributes.alphaForCaption = 0;
            const scaledImageHeight = attributes.frameForImage.height * minificationScale;
            offsetY += scaledImageHeight + (isLastItem ? options.contentInset.bottom : interSpacing);
            return attributes;
        });
        this._compressedContentSize = (0, $ba5a447b6ce1696c$exports.Size).make(bounds.width, Math.max(Math.ceil(offsetY), bounds.height));
    }
    _layoutForInteraction() {
        const transition = this._interactiveTransition;
        let { translation: translation, origin: origin, focusedIndex: focusedIndex } = transition;
        const offset = (0, $ba5a447b6ce1696c$exports.Point).from(translation);
        let targetOffsetX;
        let fromScale, toScale;
        let fromAttributes, toAttributes;
        if (transition.targetMode == $b745121b735e32e1$export$41d5aec8582771fb.compressed) {
            const attributes = this._regularLayoutAttributes[focusedIndex];
            const { minX: minX, maxX: maxX } = attributes.frame;
            // Constraint origin:
            origin.x = Math.min(Math.max(minX, origin.x), maxX);
            // Offset inside mix:
            const originPastMinX = Math.max(origin.x - minX, 0) * this._compressedLayoutAttributesScale;
            targetOffsetX = Math.abs(origin.x - originPastMinX - this._compressedLayoutAttributes[focusedIndex].frame.minX);
            fromScale = 1;
            toScale = this._compressedLayoutAttributesScale;
            fromAttributes = this._regularLayoutAttributes;
            toAttributes = this._compressedLayoutAttributes;
        } else {
            const compressedAttributes = this._compressedLayoutAttributes[focusedIndex];
            const compressedScale = this._compressedLayoutAttributesScale;
            const imageRectMinX = compressedAttributes.frame.minX; //+ (compressedAttributes.frameForImage.minX * compressedScale);
            const imageRectMaxX = imageRectMinX + compressedAttributes.frameForImage.width * compressedScale;
            // Constraint origin between `imageRectMinX` and `imageRectMaxX`
            origin.x = Math.min(Math.max(imageRectMinX, origin.x), imageRectMaxX);
            // Fix-me: Forced origin:
            if (this.options.captionPositioningMode == $b745121b735e32e1$export$d9dcde6be12ede2c.anchorToBottom) origin.x = compressedAttributes.frame.minX;
            // Scale up the offset after `imageRectMinX`
            const scaledCompressedBoundsOffsetX = Math.max(origin.x - imageRectMinX, 0) * (1 / compressedScale);
            targetOffsetX = Math.abs(origin.x - scaledCompressedBoundsOffsetX - this._regularLayoutAttributes[focusedIndex].frame.minX) * -1;
            fromScale = this._compressedLayoutAttributesScale;
            toScale = 1;
            fromAttributes = this._compressedLayoutAttributes;
            toAttributes = this._regularLayoutAttributes;
        }
        // Rubber banding:
        const restrictsWithRubberBanding = true;
        if (restrictsWithRubberBanding) {
            const sign = transition.targetMode == $b745121b735e32e1$export$41d5aec8582771fb.regular ? 1 : -1;
            const dim = targetOffsetX * -sign;
            offset.x = $b745121b735e32e1$var$clampedRubberBanding(offset.x * sign, targetOffsetX * sign, 0, {
                dim: dim
            }) * sign;
        }
        const progress = $b745121b735e32e1$var$clamp($b745121b735e32e1$var$invlerp(0, targetOffsetX, offset.x));
        const scale = $b745121b735e32e1$var$lerp(fromScale, toScale, progress);
        let focusedItemDisplacement = 0.0;
        this._layoutAttributes = fromAttributes.map((attributes, index)=>{
            const o = attributes;
            attributes = attributes.copy();
            const target = toAttributes[index];
            attributes.frame = $b745121b735e32e1$var$interpolateRect(attributes.frame, target.frame, progress, progress);
            if (attributes.itemIndex == focusedIndex) {
                const m = new DOMMatrix().translate(origin.x, origin.y).translate(offset.x, offset.y).scale(1 / fromScale).scale(scale).translate(-origin.x, -origin.y);
                const point = new DOMPoint(o.frame.origin.x, o.frame.origin.y).matrixTransform(m);
                const computedOriginY = attributes.frame.minY;
                attributes.frame.origin = (0, $ba5a447b6ce1696c$exports.Point).make(point.x, point.y);
                focusedItemDisplacement = computedOriginY - attributes.frame.minY;
            }
            attributes.transform = new DOMMatrix().scale(scale);
            if (index == focusedIndex) attributes.alphaForCaption = $b745121b735e32e1$var$lerp(attributes.alphaForCaption, target.alphaForCaption, progress);
            else attributes.alphaForCaption = 0.0;
            return attributes;
        });
        this._layoutAttributes = this._layoutAttributes.map((attributes)=>{
            if (attributes.itemIndex != focusedIndex) attributes.frame.origin.y -= focusedItemDisplacement;
            return attributes;
        });
        this._interactiveScale = scale;
        this._interactiveLayoutAttributes = this._layoutAttributes;
    }
    _layoutForInteractionCompletion() {
        const transition = this._interactiveTransition;
        const { focusedIndex: focusedIndex } = transition;
        const { progressVector: progressVector, focusedItemOrigin: focusedItemOrigin, targetOffset: targetOffset, translation: translation } = transition.transitioning;
        if (!this._interactiveLayoutAttributes) this._layoutForInteraction();
        const fromAttributes = this._interactiveLayoutAttributes;
        let targetAttributes, fromScale = this._interactiveScale, toScale;
        if (transition.targetMode == $b745121b735e32e1$export$41d5aec8582771fb.compressed) {
            targetAttributes = this._compressedLayoutAttributes;
            toScale = this._compressedLayoutAttributesScale;
        } else {
            targetAttributes = this._regularLayoutAttributes;
            toScale = 1;
        }
        const progressX = $b745121b735e32e1$var$clampedRubberBanding(progressVector.x, 0, 1, {
            dim: 1
        });
        const progressY = $b745121b735e32e1$var$clampedRubberBanding(progressVector.y, 0, 1, {
            dim: 1
        });
        const offset = (0, $ba5a447b6ce1696c$exports.Point).make($b745121b735e32e1$var$lerp(translation.x, targetOffset.x, progressX), $b745121b735e32e1$var$lerp(translation.y, targetOffset.y, progressY));
        const overallProgress = (progressX + progressY) / 2;
        const scale = $b745121b735e32e1$var$lerp(fromScale, toScale, overallProgress);
        this._layoutAttributes = this._layoutAttributes.map((attributes, index)=>{
            attributes = attributes.copy();
            const initial = fromAttributes[index];
            const target = targetAttributes[index];
            attributes.frame = $b745121b735e32e1$var$interpolateRect(initial.frame, target.frame, progressX, progressY);
            attributes.transform = new DOMMatrix().scale(scale);
            if (index == focusedIndex) {
                attributes.frame.origin = (0, $ba5a447b6ce1696c$exports.Point).from(focusedItemOrigin);
                attributes.alphaForCaption = $b745121b735e32e1$var$lerp(initial.alphaForCaption, target.alphaForCaption, overallProgress);
            } else {
                attributes.frame = attributes.frame.offsetBy(offset.x, offset.y);
                attributes.alphaForCaption = 0.0;
            }
            return attributes;
        });
    }
}
function $b745121b735e32e1$var$clampedOffset(target, lowerBound, upperBound) {
    if (target < lowerBound) {
        const diff = lowerBound - target;
        const dim = Math.abs(lowerBound);
        return lowerBound - (0, $ba5a447b6ce1696c$exports.RubberBanding).clamp(diff, {
            dim: dim
        });
    } else if (target > upperBound) {
        const boundsDimension = Math.abs(lowerBound - upperBound);
        const diff = target - upperBound;
        const dim = Math.abs(boundsDimension - upperBound);
        return upperBound + (0, $ba5a447b6ce1696c$exports.RubberBanding).clamp(diff, {
            dim: dim
        });
    } else return target;
}
function $b745121b735e32e1$var$interpolateRect(a, b, progress, progressY) {
    return (0, $ba5a447b6ce1696c$exports.Rect).make($b745121b735e32e1$var$lerp(a.origin.x, b.origin.x, progress), $b745121b735e32e1$var$lerp(a.origin.y, b.origin.y, progressY), $b745121b735e32e1$var$lerp(a.size.width, b.size.width, progress), $b745121b735e32e1$var$lerp(a.size.height, b.size.height, progressY));
}
function $b745121b735e32e1$var$clampedRubberBanding(target, lowerBound, upperBound, { dim: dim } = {}) {
    let clampedTarget = Math.min(Math.max(target, lowerBound), upperBound);
    let diff = Math.abs(target - clampedTarget);
    let sign = clampedTarget > target ? -1 : 1;
    return clampedTarget + sign * (0, $ba5a447b6ce1696c$exports.RubberBanding).clamp(diff, {
        dim: dim
    });
}


const { invlerp: $7e7f9dd2901039e2$var$invlerp, clamp: $7e7f9dd2901039e2$var$clamp } = (0, $ba5a447b6ce1696c$exports.Interpolation);
class $7e7f9dd2901039e2$var$TimelineView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    delegate;
    cells;
    rulerView;
    animator;
    layout;
    constructor(data){
        super();
        this._containerSize = (0, $ba5a447b6ce1696c$exports.Size).zero;
        this.data = data;
        this.node.className = "timeline-container";
        this.node.addEventListener("scroll", this);
        const wrapperView = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        this.wrapperView = wrapperView;
        this.addSubview(wrapperView);
        const subviews = data.map((item)=>new (0, $2a5d9fbe61164be2$export$2e2bcd8739ae039)(this));
        subviews.forEach((subview)=>wrapperView.addSubview(subview));
        this.cells = subviews;
        const rulerView = new (0, $8acc754ba5bba723$export$2e2bcd8739ae039)();
        wrapperView.addSubview(rulerView);
        this.rulerView = rulerView;
        this.addInteractions();
    }
    // - Interaction setup.
    addInteractions() {
        const handlePanGesture = ()=>{
            const { state: state, translation: translation, velocity: velocity } = gestureRecognizer;
            if (state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began) {
                if (this.animator) this.animator.stop();
                const isTouchTypeDirect = gestureRecognizer.touchesInView(this)[0].type == (0, $f83981078758ac76$export$2e2bcd8739ae039).direct;
                const minimumTranslationForMovement = isTouchTypeDirect ? 5 : 0;
                const location = gestureRecognizer.locationInView(this);
                const adjustedLocation = (0, $ba5a447b6ce1696c$exports.Point).make(location.x, location.y + this.node.scrollTop);
                const transition = this.layout.beginInteractiveTransition(adjustedLocation, {
                    minimumTranslationForMovement: minimumTranslationForMovement
                });
                transition.interactionHasMovement = ()=>{
                    this.isScrollDisabled = true;
                    this.layoutSubviews();
                };
                this.transition = transition;
                this.layoutSubviews();
            } else if (state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) {
                this.transition.updateInteractiveMovement({
                    translation: translation
                });
                this.layoutSubviews();
            } else if (state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended) {
                this.isScrollDisabled = false;
                // Don't decelerate if already completing to prioritize tap gesture:
                if (!this.isPendingInteractionCompletion) {
                    const decelerate = (0, $c6f67cca1625e9fd$export$2e2bcd8739ae039).decelerate({
                        decelerationVelocity: velocity,
                        animated: true
                    });
                    this.completeInteraction(decelerate);
                }
            } else if (state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled) {
                this.isScrollDisabled = false;
                this.completeInteraction((0, $c6f67cca1625e9fd$export$2e2bcd8739ae039).cancel({
                    animated: true
                }));
            }
        };
        const handlePanGestureShouldBegin = ()=>{
            return this.transition == undefined;
        };
        const gestureRecognizer = new (0, $e0ae29d71a91a327$export$2e2bcd8739ae039)();
        gestureRecognizer.didChange = handlePanGesture;
        gestureRecognizer.shouldBegin = handlePanGestureShouldBegin;
        gestureRecognizer.attach(this.node);
        const handleTapGesture = ()=>{
            const { state: state } = tapGestureRecognizer;
            if (state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).recognized) {
                if (!this.transition) return;
                let completion;
                if (this.layout.currentMode == (0, $b745121b735e32e1$export$41d5aec8582771fb).compressed) {
                    const location = tapGestureRecognizer.locationInView(this.node);
                    const adjustedLocation = (0, $ba5a447b6ce1696c$exports.Point).make(location.x, location.y + this.node.scrollTop);
                    const focusedIndex = this.transition.focusedIndex;
                    const didTapInsideItemBounds = this.layout.layoutAttributes[focusedIndex].frame.containsPoint(adjustedLocation);
                    if (didTapInsideItemBounds) completion = (0, $c6f67cca1625e9fd$export$2e2bcd8739ae039).focus({
                        animated: true
                    });
                }
                if (!completion) completion = (0, $c6f67cca1625e9fd$export$2e2bcd8739ae039).cancel({
                    animated: true
                });
                this.completeInteraction(completion);
            }
        };
        const tapGestureRecognizer = new (0, $890fe1ec12e520f9$export$2e2bcd8739ae039)();
        tapGestureRecognizer.didChange = handleTapGesture;
        tapGestureRecognizer.attach(this.node);
    }
    // - Layout.
    invalidateLayout() {
        const { data: data, containerSize: containerSize } = this;
        const layoutDelegate = {
            numberOfItems: data.length,
            imageSizeForItem (itemIndex) {
                const [width, height] = data[itemIndex].image.size;
                return (0, $ba5a447b6ce1696c$exports.Size).make(width, height);
            },
            captionHeightForItem (itemIndex, fittingWidth) {
                return (0, $5451dd8d7fbc9cbe$export$2e2bcd8739ae039).calculateMinimumHeightForItem(data[itemIndex], fittingWidth);
            }
        };
        const minimumEdgeSpacing = 32.0;
        const options = new (0, $b745121b735e32e1$export$5bd8911201c95c6f)();
        options.maximumRegularImageSize = (0, $ba5a447b6ce1696c$exports.Size).make(700, 700);
        options.minimumCaptionWidth = 280;
        options.captionSpacing = 32;
        options.captionPositioningMode = (0, $b745121b735e32e1$export$d9dcde6be12ede2c).anchorToBottom;
        options.contentInset = (0, $ba5a447b6ce1696c$exports.EdgeInsets).make(minimumEdgeSpacing, minimumEdgeSpacing, minimumEdgeSpacing, minimumEdgeSpacing);
        options.maximumCompressedImageSize = (0, $ba5a447b6ce1696c$exports.Size).make(100, 100);
        options.minimumInterSpacing = 32;
        options.boundsSize = containerSize;
        const minimumWidthForPositioningCaptionRight = 500.0;
        if (containerSize.width > minimumWidthForPositioningCaptionRight) options.captionPositioningMode = (0, $b745121b735e32e1$export$d9dcde6be12ede2c).right;
        const maximumReadableContentWidth = 900.0;
        const readableContentInset = minimumEdgeSpacing + Math.ceil(Math.max(containerSize.width - maximumReadableContentWidth, 0) / 2.0);
        options.contentInset.left = readableContentInset;
        options.contentInset.right = readableContentInset;
        if (!this.layout) this.layout = new (0, $b745121b735e32e1$export$17b51a93bf0e48ea)(options, layoutDelegate);
        else this.layout.options = options;
        this.rulerView.stops = this.data.map((_, index)=>containerSize.height * index);
    }
    layoutSubviews() {
        if (this.containerSize.equals((0, $ba5a447b6ce1696c$exports.Size).zero)) return;
        if (this._containerSizeInvalidated) {
            this.invalidateLayout();
            this._containerSizeInvalidated = false;
        }
        const { data: data, layout: layout, containerSize: containerSize } = this;
        // Layout:
        layout.layout();
        // Determine layout state:
        const isTransitionActive = !!this.transition;
        const isCurrentModeRegular = layout.currentMode == (0, $b745121b735e32e1$export$41d5aec8582771fb).regular;
        const isCaptionPositioningAnchored = layout.options.captionPositioningMode == (0, $b745121b735e32e1$export$d9dcde6be12ede2c).anchorToBottom;
        const isSnapActive = isCurrentModeRegular && !isTransitionActive;
        const isScrollDisabled = this.isScrollDisabled;
        // Determine options for cell:
        const optionsForCell = {
            selectable: !isTransitionActive && !isCurrentModeRegular
        };
        // Apply layout:
        for (const attributes of layout.layoutAttributes){
            const cell = this.cells[attributes.itemIndex];
            const dataForItem = data[attributes.itemIndex];
            cell.configure({
                attributes: attributes,
                data: dataForItem,
                options: optionsForCell
            });
        }
        // Update container and views:
        const { contentSize: contentSize } = layout;
        const { style: nodeStyle } = this.node;
        nodeStyle.position = "relative";
        nodeStyle.width = `${containerSize.width}px`;
        nodeStyle.height = `${containerSize.height}px`;
        nodeStyle.overflowX = "hidden";
        nodeStyle.overflowY = isScrollDisabled ? "hidden" : "scroll";
        nodeStyle.scrollSnapType = isSnapActive ? "y mandatory" : "none";
        const { style: wrapperStyle } = this.wrapperView.node;
        wrapperStyle.width = `${contentSize.width}px`;
        wrapperStyle.height = `${contentSize.height}px`;
        wrapperStyle.overflow = "hidden";
        wrapperStyle.touchAction = "pan-y zoom";
        this.rulerView.enabled = isSnapActive;
        const { classList: classList } = this.node;
        classList.toggle("compressed", !isCurrentModeRegular);
        classList.toggle("caption-anchored-bottom", isCaptionPositioningAnchored);
        classList.toggle("caption-right", !isCaptionPositioningAnchored);
        this._triggerEventForFocusLayout();
    }
    set containerSize(size) {
        if (!this._containerSize.equals(size)) {
            this._containerSize = (0, $ba5a447b6ce1696c$exports.Size).from(size);
            this._containerSizeInvalidated = true;
        }
    }
    get containerSize() {
        return this._containerSize.copy();
    }
    // - Interaction completion.
    completeInteraction(parameters) {
        this._finishingParameters = parameters;
        // Schedule if needed:
        if (!this._finishing) {
            this._finishing = true;
            const finish = ()=>{
                this._finishing = false;
                this._completeInteraction(this._finishingParameters);
            };
            window.requestAnimationFrame(finish);
        }
    }
    get isPendingInteractionCompletion() {
        return this._finishing;
    }
    // - Performs a layout transition:
    _beginTransitionTo(targetLayoutMode, targetScrollTop) {
        const { layout: layout, transition: transition } = this;
        // Calculate the target scroll top and re-anchor the screen to it:
        const scrollTop = this.node.scrollTop;
        if (scrollTop != targetScrollTop) {
            // Disable scroll for a moment and set it:
            const { style: nodeStyle } = this.node;
            const { overflowY: overflowY } = nodeStyle;
            nodeStyle.overflowY = "hidden";
            this.node.scrollTop = targetScrollTop;
            nodeStyle.overflowY = overflowY;
            // Prevents bug in Safari were the actual UIScrollView keeps decelerating to an incorrect target:
            window.requestAnimationFrame(()=>{
                this.node.scrollTop = targetScrollTop;
            });
        }
        // Let's also calculate a translation vector for what we just did:
        const scrollTopTranslation = (0, $ba5a447b6ce1696c$exports.Point).make(0, targetScrollTop - scrollTop);
        // Re-center the currently focused item on the visible area of the screen:
        const focusedItemAttributes = layout.layoutAttributes[transition.focusedIndex];
        const focusedItemOrigin = (0, $ba5a447b6ce1696c$exports.Point).from(focusedItemAttributes.frame.origin);
        focusedItemOrigin.y += scrollTopTranslation.y;
        // Configure the transition to the correct target mode:
        transition.targetMode = targetLayoutMode;
        // Drive transition with progress zero to prevent flick:
        this._driveTransition({
            progressVector: (0, $ba5a447b6ce1696c$exports.Point).zero,
            focusedItemOrigin: focusedItemOrigin,
            scrollTopTranslation: scrollTopTranslation
        });
        // Notify:
        this._triggerEventForTransition(true, transition);
        return {
            scrollTopTranslation: scrollTopTranslation,
            focusedItemOrigin: focusedItemOrigin
        };
    }
    _driveTransition(state) {
        const { transition: transition } = this;
        const { progressVector: progressVector, focusedItemOrigin: focusedItemOrigin, scrollTopTranslation: scrollTopTranslation } = state;
        transition.setTransitionProgress(progressVector, {
            focusedItemOrigin: // Animate the focused cell independently:
            focusedItemOrigin,
            // Preserve the translation:
            translation: scrollTopTranslation
        });
        this.layoutSubviews();
    }
    _endTransition() {
        const { transition: transition } = this;
        transition.complete(true);
        this.transition = undefined;
        this.animator = undefined;
        this.layoutSubviews();
        this._triggerEventForTransition(false, transition);
    }
    _completeInteraction(completion) {
        const { layout: layout, transition: transition } = this;
        if (!transition) throw new Error("Internal consistency error: No transition to finish.");
        if (this.isCompletingInteraction) return;
        this.isCompletingInteraction = true;
        const calculateScrollTopForCenteringItem = (focusedIndex, mode)=>{
            const { containerSize: containerSize } = this;
            if (mode == (0, $b745121b735e32e1$export$41d5aec8582771fb).regular) return containerSize.height * focusedIndex;
            else {
                const { frame: frame } = layout.finalLayoutAttributesForItem(focusedIndex, mode);
                const { containerSize: containerSize } = this;
                let scrollTop = Math.floor(frame.minY - (containerSize.height - frame.height));
                scrollTop = Math.max(scrollTop, 0);
                scrollTop = Math.min(scrollTop, this.layout.contentSizeForMode(mode).height - containerSize.height);
                return scrollTop;
            }
        };
        const solveCompletion = (completion)=>{
            let targetLayoutMode, targetScrollTop;
            const { focus: focus, unfocus: unfocus, cancel: cancel, decelerate: decelerate } = (0, $c6f67cca1625e9fd$export$2e2bcd8739ae039).type;
            switch(completion.type){
                case focus:
                case unfocus:
                    targetLayoutMode = completion.type == focus ? (0, $b745121b735e32e1$export$41d5aec8582771fb).regular : (0, $b745121b735e32e1$export$41d5aec8582771fb).compressed;
                    targetScrollTop = calculateScrollTopForCenteringItem(transition.focusedIndex, targetLayoutMode);
                    break;
                case cancel:
                    targetLayoutMode = layout.currentMode;
                    targetScrollTop = this.node.scrollTop;
                    break;
                case decelerate:
                    const { decelerationVelocity: decelerationVelocity } = completion.parameters;
                    const fi = transition.focusedIndex;
                    const regular = layout.finalLayoutAttributesForItem(fi, (0, $b745121b735e32e1$export$41d5aec8582771fb).regular).frame.origin.copy();
                    const compressed = layout.finalLayoutAttributesForItem(fi, (0, $b745121b735e32e1$export$41d5aec8582771fb).compressed).frame.origin.copy();
                    regular.y = 0.0, compressed.y = 0.0; // Hack: Make it so they both match the engine's content offset.
                    const engine = new (0, $ac4c9aa809454a83$export$2e2bcd8739ae039)();
                    engine.directionalLockEnabled = false;
                    engine.contentOffset = layout.layoutAttributes[fi].frame.origin;
                    engine.anchorLimits = [
                        regular,
                        compressed
                    ];
                    const anchor = engine.nearestAnchorForDragging({
                        decelerationVelocity: decelerationVelocity
                    });
                    targetLayoutMode = anchor.equals(regular) ? (0, $b745121b735e32e1$export$41d5aec8582771fb).regular : (0, $b745121b735e32e1$export$41d5aec8582771fb).compressed;
                    targetScrollTop = calculateScrollTopForCenteringItem(transition.focusedIndex, targetLayoutMode);
                    break;
            }
            return {
                targetLayoutMode: targetLayoutMode,
                targetScrollTop: targetScrollTop,
                animated: completion.parameters.animated
            };
        };
        // Calculate targets:
        const { targetLayoutMode: targetLayoutMode, targetScrollTop: targetScrollTop, animated: animated } = solveCompletion(completion);
        const focusedItemOriginTarget = layout.finalLayoutAttributesForItem(transition.focusedIndex, targetLayoutMode).frame.origin;
        // Begin transition:
        const { scrollTopTranslation: scrollTopTranslation, focusedItemOrigin: focusedItemOrigin } = this._beginTransitionTo(targetLayoutMode, targetScrollTop);
        // Define a callback that ends the transition to call later:
        const completeTransition = ()=>{
            this._endTransition();
            this.isCompletingInteraction = false;
        };
        if (animated) {
            const engine = new (0, $ac4c9aa809454a83$export$2e2bcd8739ae039)();
            engine.contentSize = layout.contentSizeForMode(targetLayoutMode);
            engine.contentOffset = focusedItemOrigin;
            engine.anchorLimits = [
                focusedItemOriginTarget
            ];
            const { decelerationVelocity: decelerationVelocity } = completion.parameters;
            const targetContentOffset = (0, $ba5a447b6ce1696c$exports.Point).zero;
            const animates = engine.endDragging({
                decelerationVelocity: decelerationVelocity
            }, {
                willAnimate: (target)=>{
                    // TODO: Target should override content offset sometimes?
                    targetContentOffset.x = target.x;
                    targetContentOffset.y = target.y;
                },
                didAnimate: ()=>{
                    const offset = engine.contentOffset;
                    const from = focusedItemOrigin, to = targetContentOffset;
                    // Calculate progress vector:
                    const progress = (0, $ba5a447b6ce1696c$exports.Point).make(from.x == to.x ? NaN : $7e7f9dd2901039e2$var$invlerp(from.x, to.x, offset.x), from.y == to.y ? NaN : $7e7f9dd2901039e2$var$invlerp(from.y, to.y, offset.y));
                    if (isNaN(progress.x)) progress.x = isNaN(progress.y) ? 0.0 : progress.y;
                    if (isNaN(progress.y)) progress.y = isNaN(progress.x) ? 0.0 : progress.x;
                    // Drive:
                    const state = {
                        progressVector: progress,
                        scrollTopTranslation: scrollTopTranslation,
                        focusedItemOrigin: offset
                    };
                    this._driveTransition(state);
                },
                didFinish: (completed)=>{
                    completeTransition();
                }
            });
            if (!animates) window.requestAnimationFrame(()=>completeTransition());
        } else completeTransition();
        this.layoutSubviews();
    }
    // - Delegate
    _triggerEventForTransition(beginOrEnd, transition) {
        const state = {
            isFocused: transition.targetMode == (0, $b745121b735e32e1$export$41d5aec8582771fb).regular,
            item: transition.focusedIndex
        };
        if (beginOrEnd) this.delegate.timelineViewWillTransition(this, state);
        else this.delegate.timelineViewDidTransition(this, state);
    }
    _triggerEventForFocusLayout() {
        const { transition: transition, layout: layout } = this;
        let percentComplete;
        if (transition) {
            const from = layout.finalLayoutAttributesForItem(transition.focusedIndex, (0, $b745121b735e32e1$export$41d5aec8582771fb).compressed).frame.minX;
            const to = this.containerSize.width / 2.0;
            const current = layout.layoutAttributes[transition.focusedIndex].frame.minX;
            percentComplete = $7e7f9dd2901039e2$var$invlerp(from, to, current);
            percentComplete = $7e7f9dd2901039e2$var$clamp(percentComplete);
        } else percentComplete = layout.currentMode == (0, $b745121b735e32e1$export$41d5aec8582771fb).compressed ? 0.0 : 1.0;
        if (this._focusInteractionPercentComplete != percentComplete) {
            this._focusInteractionPercentComplete = percentComplete;
            this.delegate.timelineViewFocusInteractionDidChange(this, {
                percentComplete: percentComplete
            });
        }
    }
    // - Cell delegate.
    didSelectTimelineCellForItem(_, item) {
        this.focusView(item, {
            animated: true
        });
    }
    // - Actions
    focusView(item, { animated: animated = false }) {
        if (this.transition) return; // Ignore.
        this.transition = this.layout.beginInteractiveTransitionCenteredOnItem(item);
        this.layoutSubviews();
        const completion = (0, $c6f67cca1625e9fd$export$2e2bcd8739ae039).focus({
            animated: animated
        });
        this.completeInteraction(completion);
    }
    popFocusedView({ animated: animated = false } = {}) {
        const { layout: layout, transition: transition } = this;
        if (transition || layout.currentMode != (0, $b745121b735e32e1$export$41d5aec8582771fb).regular) return;
        const { height: height } = this.containerSize;
        let item = Math.round((this.node.scrollTop + height / 2.0) / height) - 1;
        item = Math.max(Math.min(item, this.cells.length - 1), 0);
        this.transition = this.layout.beginInteractiveTransitionCenteredOnItem(item);
        this.layoutSubviews();
        const completion = (0, $c6f67cca1625e9fd$export$2e2bcd8739ae039).unfocus({
            animated: animated
        });
        this.completeInteraction(completion);
    }
    get isFocused() {
        return this.layout.currentMode == (0, $b745121b735e32e1$export$41d5aec8582771fb).regular;
    }
    // - Scroll.
    handleScrollDidChange(scrollTop) {
        let itemIndex = 0;
        if (this.isCompletingInteraction) return;
        for (const layout of this.layout.layoutAttributes)if (scrollTop < layout.frame.midY) {
            itemIndex = layout.itemIndex;
            break;
        }
        if (this._visibleIndex != itemIndex) {
            this._visibleIndex = itemIndex;
            this.delegate.timelineViewDidScroll(this, {
                itemIndex: itemIndex
            });
        }
    }
    // – Event handling.
    handleEvent(event) {
        switch(event.type){
            case "scroll":
                if (!this._trackingScrollEvent) {
                    this._trackingScrollEvent = true;
                    const { scrollTop: scrollTop } = this.node;
                    window.requestAnimationFrame(()=>{
                        this.handleScrollDidChange(scrollTop);
                        this._trackingScrollEvent = false;
                    });
                }
                break;
        }
    }
}
var $7e7f9dd2901039e2$export$2e2bcd8739ae039 = $7e7f9dd2901039e2$var$TimelineView;


// 
// SidebarView.js
// portfolio
// 
// Created on 6/18/23
// 


const { lerp: $e72aa93d38e7c695$var$lerp } = (0, $ba5a447b6ce1696c$exports.Interpolation);
class $e72aa93d38e7c695$var$SidebarView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    delegate;
    yearNode;
    constructor({ header: header, navigation: navigation, featurette: featurette, footer: footer } = {}){
        super();
        this.node.innerHTML = `
    <div class="sidebar-wrapper">
      <div class="sidebar-content">
        <header>
          <h1>
            <span role="text">${header.title.replace(" ", `<br>`)}</span>
          </h1>
          <h3><span class="year">${header.year}</span></h3>
        </header>
        
        <nav>
          <ul>
            ${navigation.map(({ title: title, url: url, inline: inline, rel: rel } = {})=>`<li><a href="${url}" ${inline ? "data-open-inline" : `target="_blank"`} ${rel ? `rel="${rel}"` : ""}>${title}</a></li>`).join("")}
          </ul>
        </nav>
        
        ${featurette ? `
          <nav>
            <a href="${featurette.url}" class="featurette">
              <figure>
                <img src="${featurette.image.src}" width="${featurette.image.size[0]}" height="${featurette.image.size[1]}" alt="${featurette.image.alt}">
              </figure>
              
              <span class="label">
                <span class="title">${featurette.title}</span>
                <span class="subtitle">${featurette.subtitle}</span>
              </span>
            </a>
          </nav>` : ""}
      </div>
      
      <footer>
        <div class="footer-content">${footer}</div>
      </footer>
    </div>
    `;
        const handleInlineClickEvent = (event)=>{
            event.preventDefault();
            const identifier = event.target.getAttribute("href");
            const { delegate: delegate } = this;
            if (delegate) delegate.sidebarDidSelectLink(this, identifier);
        };
        for (const element of this.node.querySelectorAll("a[data-open-inline]"))element.addEventListener("click", handleInlineClickEvent);
        this.yearNode = this.node.querySelector(".year");
    }
    configureDisappearPercent(disappearPercent = 0.0) {
        const maximumScale = 1, minimumScale = 0.95;
        const scale = $e72aa93d38e7c695$var$lerp(maximumScale, minimumScale, disappearPercent);
        const isHidden = disappearPercent >= 0.99;
        const { style: style, classList: classList } = this.node;
        style.transform = new DOMMatrix().scale(scale);
        style.opacity = 1 - disappearPercent;
        classList.toggle("is-hidden", isHidden);
    }
    configureCurrentYear(year) {
        this.yearNode.textContent = year;
    }
}
var $e72aa93d38e7c695$export$2e2bcd8739ae039 = $e72aa93d38e7c695$var$SidebarView;


// 
// PageContainerView.js
// portfolio
// 
// Created on 6/22/23
//



class $850faa05cf8fac7a$var$PageContainerTransitioning {
    static animate = "animate";
    static willAppear = "will-appear";
    static willDisappear = "will-disappear";
    static willDisappearInteractive = "will-disappear-interactive";
}
class $850faa05cf8fac7a$var$PageContainerView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    wrapperView;
    animator;
    transition;
    _contentView;
    _navigationContainerView;
    get contentView() {
        return this._contentView;
    }
    get navigationContainerView() {
        return this._navigationContainer;
    }
    constructor(contentView){
        super();
        this.node.className = "page-container";
        this.polyfillIfNeeded();
        // Events:
        this.node.addEventListener("transitionend", this);
        this.node.addEventListener("cancel", this);
        // Wrapper view:
        const wrapperContainerView = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        wrapperContainerView.node.className = "page-container-wrapper";
        wrapperContainerView.node.style.touchAction = "zoom";
        const wrapperView = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        wrapperView.node.className = "page-container-content";
        wrapperContainerView.addSubview(wrapperView);
        this.addSubview(wrapperContainerView);
        wrapperView.addSubview(contentView);
        this.wrapperView = wrapperContainerView;
        this._contentView = contentView;
        // Navigation container:
        const navigationContainerView = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        navigationContainerView.node.className = "page-container-navigation";
        this._navigationContainer = navigationContainerView;
        this.addSubview(navigationContainerView);
        // Gestures:
        this.addInteractions();
    }
    makeNode(document) {
        return document.createElement("dialog");
    }
    addInteractions() {
        const didPan = ()=>{
            const { state: state, translation: translation, velocity: velocity } = panGestureRecognizer;
            switch(state){
                case (0, $0d409e98add6de65$export$2e2bcd8739ae039).began:
                    const { clientWidth: clientWidth, clientHeight: clientHeight } = this.wrapperView.node;
                    if (!this.animator) this.animator = new (0, $ac4c9aa809454a83$export$2e2bcd8739ae039)();
                    const animator = this.animator;
                    animator.boundsSize = (0, $ba5a447b6ce1696c$exports.Size).make(clientWidth, clientHeight);
                    animator.contentSize = (0, $ba5a447b6ce1696c$exports.Size).make(clientWidth, clientHeight * 2.0);
                    animator.anchorLimits = [
                        (0, $ba5a447b6ce1696c$exports.Point).zero,
                        (0, $ba5a447b6ce1696c$exports.Point).make(0, -clientHeight)
                    ];
                    animator.startDragging();
                    this.animator = animator;
                    break;
                case (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed:
                    this.animator.continueDragging(translation.x, translation.y * -1);
                    this.configureWrapper({
                        contentOffset: this.animator.contentOffset
                    });
                    break;
                case (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended:
                    this.decelerate({
                        velocity: velocity
                    });
                    break;
                case (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled:
                    break;
            }
        };
        const shouldBegin = (gestureRecognizer)=>{
            const isTouchTypeDirect = gestureRecognizer.touchesInView(this)[0].type == (0, $f83981078758ac76$export$2e2bcd8739ae039).direct;
            if (isTouchTypeDirect) return false;
            return this.transition == undefined;
        };
        const panGestureRecognizer = new (0, $e0ae29d71a91a327$export$2e2bcd8739ae039)();
        panGestureRecognizer.didChange = didPan;
        panGestureRecognizer.shouldBegin = shouldBegin;
        panGestureRecognizer.attach(this.wrapperView.node);
    }
    configureWrapper({ contentOffset: contentOffset } = {}) {
        const { wrapperView: wrapperView } = this;
        const { node: node } = wrapperView;
        const transform = new DOMMatrix().translate(contentOffset.x, contentOffset.y * -1);
        node.style.transform = transform;
    }
    decelerate({ velocity: velocity } = {}) {
        const { animator: animator } = this;
        velocity = (0, $ba5a447b6ce1696c$exports.Point).from(velocity);
        velocity.y *= -1;
        let dismissing = false;
        animator.endDragging({
            decelerationVelocity: velocity
        }, {
            willAnimate: (targetContentOffset)=>{
                dismissing = targetContentOffset.y != 0.0;
                if (dismissing) {
                    const { node: node } = this;
                    const transition = {
                        name: $850faa05cf8fac7a$var$PageContainerTransitioning.willDisappearInteractive
                    };
                    this.transition = transition;
                    node.classList.add(transition.name);
                    window.requestAnimationFrame(()=>{
                        node.classList.add($850faa05cf8fac7a$var$PageContainerTransitioning.animate);
                    });
                }
            },
            didAnimate: ()=>{
                const { contentOffset: contentOffset } = animator;
                this.configureWrapper({
                    contentOffset: contentOffset
                });
            },
            didFinish: ()=>{
                if (dismissing) this._remove();
            }
        });
    }
    handleEvent(event) {
        if (event.target != this.node) return;
        switch(event.type){
            case "transitionend":
                const { transition: transition } = this;
                if (transition) {
                    this.node.classList.remove(transition.name, $850faa05cf8fac7a$var$PageContainerTransitioning.animate);
                    if (transition.name == $850faa05cf8fac7a$var$PageContainerTransitioning.willDisappear || transition.name == $850faa05cf8fac7a$var$PageContainerTransitioning.willDisappearInteractive) this._remove();
                    this.transition = undefined;
                }
                break;
            case "cancel":
                event.preventDefault();
                this.dismiss();
                break;
            default:
                break;
        }
    }
    presentInView(presentingView, { animated: animated = true } = {}) {
        if (this.transition) {
            console.warn("Skipping `presentInView()`, there's an ongoing transition:", this.transition);
            return;
        }
        const { node: containerNode } = presentingView;
        const { node: node } = this;
        containerNode.appendChild(node);
        if (animated) {
            const transition = {
                name: $850faa05cf8fac7a$var$PageContainerTransitioning.willAppear
            };
            this.transition = transition;
            window.requestAnimationFrame(()=>{
                node.classList.add(transition.name);
                node.showModal();
                window.requestAnimationFrame(()=>{
                    node.classList.add($850faa05cf8fac7a$var$PageContainerTransitioning.animate);
                });
            });
        } else window.requestAnimationFrame(()=>node.showModal());
    }
    dismiss({ animated: animated = true } = {}) {
        if (this.transition) {
            console.warn("Skipping `dismiss()`, there's an ongoing transition:", this.transition);
            return;
        }
        if (animated) {
            const { node: node } = this;
            const transition = {
                name: $850faa05cf8fac7a$var$PageContainerTransitioning.willDisappear
            };
            this.transition = transition;
            window.requestAnimationFrame(()=>{
                node.classList.add(transition.name);
                window.requestAnimationFrame(()=>{
                    node.classList.add($850faa05cf8fac7a$var$PageContainerTransitioning.animate);
                });
            });
        } else this._remove();
    }
    _remove() {
        this.node.close();
        this.removeFromSuperview();
        const { didDisappear: didDisappear } = this;
        if (didDisappear) didDisappear();
    }
    polyfillIfNeeded() {
        const { node: node } = this;
        const { style: style } = node;
        const openAttributeName = "open";
        if (!node.showModal) node.showModal = ()=>{
            node.setAttribute(openAttributeName, "");
            style.display = undefined;
            style.top = "0px";
            style.left = "0px";
            style.width = "100%";
            style.height = "100%";
            style.position = "fixed";
            style.zIndex = "999";
        };
        if (!node.close) node.close = ()=>{
            node.removeAttribute(openAttributeName);
            node.style.display = "none";
        };
    }
}
var $850faa05cf8fac7a$export$2e2bcd8739ae039 = $850faa05cf8fac7a$var$PageContainerView;


// 
// AboutView.js
// portfolio
// 
// Created on 6/27/23
// 


// 
// PolaroidCell.js
// portfolio
// 
// Created on 6/27/23
// 


class $e9911ea16a77b311$var$PolaroidCell extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    wrapperView;
    imageView;
    constructor(){
        super();
        const { node: node } = this;
        const { style: style } = node;
        node.className = "polaroid";
        style.display = "block";
        style.position = "absolute";
        style.touchAction = "none";
        const wrapperView = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        wrapperView.node.className = "polaroid-image-wrapper";
        this.wrapperView = wrapperView;
        this.addSubview(wrapperView);
        const imageView = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        imageView.node.className = "polaroid-image";
        this.imageView = imageView;
        wrapperView.addSubview(imageView);
    }
    makeNode(document) {
        return document.createElement("figure");
    }
    configure({ src: src, webp: webp, alt: alt } = {}) {
        this.imageView.node.innerHTML = `
      <picture>
        <source srcset="${webp}" type="image/webp" />
        <img src="${src}" alt="${alt}">
      </picture>
    `;
        this.node.title = alt;
    }
    beginLift({ origin: origin = (0, $ba5a447b6ce1696c$exports.Point).zero } = {}) {
        this.node.classList.add("lift");
        this.node.transformOrigin = `${origin.x}px ${origin.y}px`;
    }
    endLift() {
        this.node.classList.remove("lift");
    }
}
var $e9911ea16a77b311$export$2e2bcd8739ae039 = $e9911ea16a77b311$var$PolaroidCell;


class $188df402e395a2eb$var$AboutView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    imageWrapperView;
    panGestureRecognizer;
    constructor(data){
        super();
        this.node.className = "about-images";
        this.node.style.position = "relative";
        this.data = data;
        const imageWrapper = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        imageWrapper.node.className = "about-images-wrapper";
        imageWrapper.node.style.position = "relative";
        this.imageWrapperView = imageWrapper;
        this.addSubview(imageWrapper);
        for (const image of data)this.insertPolaroid(image);
    }
    handlePanGestureRecognizer(panGestureRecognizer, view) {
        const { state: state, translation: translation, event: event } = panGestureRecognizer;
        switch(state){
            case (0, $0d409e98add6de65$export$2e2bcd8739ae039).began:
                // Required so we cancel other recognizers:
                event.stopPropagation();
                // Stop and capture initial transform:
                view.animator?.stop();
                view.initialTransform = new DOMMatrix(view.node.style.transform);
                // Bring to front:
                view.superview.addSubview(view);
                // Begin lift:
                const origin = panGestureRecognizer.locationInView(view);
                const lift = ()=>view.beginLift({
                        origin: origin
                    });
                window.requestAnimationFrame(lift);
                break;
            case (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed:
                view.node.style.transform = new DOMMatrix().translate(translation.x, translation.y).multiply(view.initialTransform);
                break;
            case (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended:
            case (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled:
                const { initialTransform: initialTransform } = view;
                const { velocity: velocity } = panGestureRecognizer;
                const parameters = {
                    decelerationVelocity: velocity
                };
                const engine = new (0, $ac4c9aa809454a83$export$2e2bcd8739ae039)();
                engine.directionalLockEnabled = false;
                engine.decelerationRate = 0.98; // ScrollEngineDecelerationRate.fast;
                engine.contentOffset = translation;
                engine.anchorLimits = [
                    engine.projectionForDragging(parameters)
                ];
                engine.endDragging(parameters, {
                    willAnimate: ()=>{
                    // Do nothing.
                    },
                    didAnimate: ()=>{
                        const { contentOffset: contentOffset } = engine;
                        const transform = new DOMMatrix().translate(contentOffset.x, contentOffset.y).multiply(initialTransform);
                        view.node.style.transform = transform;
                        view.initialTransform = transform;
                    },
                    didFinish: ()=>{
                    // Do nothing.
                    }
                });
                view.animator = engine;
                view.endLift();
                break;
        }
    }
    insertPolaroid(data) {
        const view = new (0, $e9911ea16a77b311$export$2e2bcd8739ae039)();
        view.configure(data);
        const panGestureRecognizer = new (0, $e0ae29d71a91a327$export$2e2bcd8739ae039)();
        panGestureRecognizer.didChange = this.handlePanGestureRecognizer.bind(this, panGestureRecognizer, view);
        panGestureRecognizer.attach(view.node);
        view.gestureRecognizer = panGestureRecognizer;
        this.imageWrapperView.addSubview(view);
    }
}
var $188df402e395a2eb$export$2e2bcd8739ae039 = $188df402e395a2eb$var$AboutView;


// 
// sluggify.js
// portfolio
// 
// Created on 7/5/23
// 
function $bdf0e88ecc854368$var$slugify(str) {
    str = str.replace(/^\s+|\s+$/g, ""); // trim leading/trailing white space
    str = str.toLowerCase(); // convert string to lowercase
    str = str.replace(/[^a-z0-9 -]/g, "") // remove any non-alphanumeric characters
    .replace(/\s+/g, "-") // replace spaces with hyphens
    .replace(/-+/g, "-"); // remove consecutive hyphens
    return str;
}
var $bdf0e88ecc854368$export$2e2bcd8739ae039 = $bdf0e88ecc854368$var$slugify;


// 
// Button.js
// portfolio
// 
// Created on 6/17/23
// 

class $407ffebd6b13ddd4$var$Button extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    primaryAction;
    _keyEquivalent;
    makeNode(document1) {
        return document1.createElement("button");
    }
    constructor(){
        super();
        this.node.addEventListener("click", this);
    }
    handleEvent(event) {
        switch(event.type){
            case "click":
                this._triggerPrimaryAction(event);
                break;
            case "keydown":
                if (this._isKeyEquivalent(event.key)) this._triggerPrimaryAction(event);
                break;
        }
    }
    _triggerPrimaryAction(event) {
        const { primaryAction: primaryAction } = this;
        if (primaryAction) primaryAction(event);
    }
    set keyEquivalent(chars) {
        this._keyEquivalent = chars;
        if (chars) document.addEventListener("keydown", this);
        else document.removeEventListener("keydown", this);
    }
    get keyEquivalent() {
        return this._keyEquivalent;
    }
    _isKeyEquivalent(key) {
        const { _keyEquivalent: record } = this;
        if (Array.isArray(record)) return record.indexOf(key) != -1;
        else return record === key;
    }
}
var $407ffebd6b13ddd4$export$2e2bcd8739ae039 = $407ffebd6b13ddd4$var$Button;


// 
// Symbol.js
// portfolio
// 
// Created on 6/24/23
// 

var $31c551cf2d2d64f2$exports = {};
$31c551cf2d2d64f2$exports = "<svg width=\"16\" height=\"22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path opacity=\".9\" d=\"M10.723 22 0 11 10.723 0 13 2.313l-8.876 8.673L13 19.676 10.723 22Z\"/></svg>";


var $03a11da0d223f85a$exports = {};
$03a11da0d223f85a$exports = "<svg width=\"20\" height=\"20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.625 20 0 2.375 2.375 0 20 17.625 17.625 20Zm-15.25 0L0 17.625 17.625 0 20 2.375 2.375 20Z\"/></svg>";


class $9665f586a0d90d94$var$Symbol extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    static get chevronBackward() {
        return new $9665f586a0d90d94$var$Symbol((0, (/*@__PURE__*/$parcel$interopDefault($31c551cf2d2d64f2$exports))));
    }
    static get xmark() {
        return new $9665f586a0d90d94$var$Symbol((0, (/*@__PURE__*/$parcel$interopDefault($03a11da0d223f85a$exports))));
    }
    constructor(src){
        super();
        this.node.innerHTML = src;
        this.node.className = "symbol";
    }
}
var $9665f586a0d90d94$export$2e2bcd8739ae039 = $9665f586a0d90d94$var$Symbol;


class $947d90383f4d5760$var$RootView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    data;
    timelineView;
    sidebarView;
    backButton;
    constructor(data){
        super();
        this.data = data;
        this.node.className = "root-view";
        // Sidebar:
        const sidebarView = new (0, $e72aa93d38e7c695$export$2e2bcd8739ae039)(data);
        sidebarView.node.className = "sidebar";
        sidebarView.delegate = this;
        this.sidebarView = sidebarView;
        this.addSubview(sidebarView);
        // Initialize timeline:
        const timelineView = new (0, $7e7f9dd2901039e2$export$2e2bcd8739ae039)(data.work);
        timelineView.delegate = this;
        this.timelineView = timelineView;
        this.addSubview(timelineView);
        // Navigation:
        const backButton = new (0, $407ffebd6b13ddd4$export$2e2bcd8739ae039)();
        backButton.primaryAction = ()=>timelineView.popFocusedView({
                animated: true
            });
        backButton.keyEquivalent = [
            "Escape",
            "ArrowRight"
        ];
        backButton.node.className = "navigation-button back-button";
        backButton.node.title = "Back";
        backButton.addSubview((0, $9665f586a0d90d94$export$2e2bcd8739ae039).chevronBackward);
        this.backButton = backButton;
        this.addSubview(backButton);
        // Window sizing:
        window.addEventListener("resize", ()=>this.layoutSubviews());
        window.addEventListener("focus", ()=>this.layoutSubviews());
        // Do a layout pass:
        this.layoutSubviews();
        // Route if needed:
        const currentPageLink = window.location.pathname;
        if (currentPageLink && currentPageLink != "/") this.route(currentPageLink);
    }
    layoutSubviews() {
        const { innerWidth: width, innerHeight: height } = window;
        const containerSize = {
            width: width,
            height: height
        };
        const { timelineView: timelineView } = this;
        timelineView.containerSize = containerSize;
        timelineView.layoutSubviews();
        const { sidebarView: sidebarView } = this;
        sidebarView.node.style.left = `${timelineView.layout.options.contentInset.left}px`;
    }
    presentPage(link, { animated: animated = false } = {}) {
        const page = this.data.pages[link];
        if (!page) throw new Error(`Cannot handle page "${link}".`);
        this.setSubpage(link, page.title);
        const view = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        view.node.className = `page-container ${link}`;
        view.node.innerHTML = page.body;
        if (link == "/about/") view.addSubview(new (0, $188df402e395a2eb$export$2e2bcd8739ae039)(page.images));
        const dismissButton = new (0, $407ffebd6b13ddd4$export$2e2bcd8739ae039)();
        dismissButton.node.className = "navigation-button dismiss-button";
        dismissButton.node.title = "Close";
        dismissButton.primaryAction = ()=>{
            containerView.dismiss();
        };
        dismissButton.addSubview((0, $9665f586a0d90d94$export$2e2bcd8739ae039).xmark);
        const containerView = new (0, $850faa05cf8fac7a$export$2e2bcd8739ae039)(view);
        containerView.didDisappear = ()=>{
            this.popSubpage();
        };
        containerView.navigationContainerView.addSubview(dismissButton);
        containerView.presentInView(this, {
            animated: animated
        });
        // Workaround to avoid visible focused dismiss:
        const setDismissVisibility = (visiblity)=>dismissButton.node.style.visibility = visiblity;
        setDismissVisibility("hidden");
        window.requestAnimationFrame(()=>setDismissVisibility(""));
    }
    setSubpage(path = "/", subtitle) {
        const { title: title } = this.data.header;
        document.title = subtitle ? `${subtitle} \u{2014} ${title}` : title;
        window.history.replaceState({}, undefined, path);
    }
    popSubpage() {
        this.setSubpage();
    }
    route(path) {
        const { data: data } = this;
        try {
            const currentPage = data.pages[path];
            if (currentPage) this.presentPage(path);
            else {
                const components = path.split("/").filter((letter)=>letter !== "");
                if (components.length == 2) {
                    const [year, slug] = components;
                    const match = data.work.findIndex((item)=>item.year == year && (0, $bdf0e88ecc854368$export$2e2bcd8739ae039)(item.title) == slug);
                    if (match != -1) this.timelineView.focusView(match, {
                        animated: false
                    });
                    else throw new Error("Slug didn't match.");
                } else throw new Error("Components didn't match for a slug.");
            }
        } catch (error) {
            this.presentPage("/404/");
        }
    }
    // - SidebarView delegate
    sidebarDidSelectLink(_, link) {
        this.presentPage(link, {
            animated: true
        });
    }
    // - TimelineView delegate
    timelineViewWillTransition(_, { isFocused: isFocused, item: item } = state) {
        this.node.classList.toggle("is-focused", isFocused);
        if (isFocused) {
            this.backButton.node.tabIndex = "1";
            const work = this.data.work[item];
            const slug = `/${work.year}/${(0, $bdf0e88ecc854368$export$2e2bcd8739ae039)(work.title)}/`;
            this.setSubpage(slug, work.title);
        } else {
            this.backButton.node.removeAttribute("tabIndex");
            this.popSubpage();
        }
    }
    timelineViewDidTransition(_) {
    // Nothing.
    }
    timelineViewFocusInteractionDidChange(_, { percentComplete: percentComplete }) {
        this.sidebarView.configureDisappearPercent(percentComplete);
    }
    timelineViewDidScroll(_, { itemIndex: itemIndex } = {}) {
        if (this.timelineView.isFocused) {
            const work = this.data.work[itemIndex];
            const slug = `/${work.year}/${(0, $bdf0e88ecc854368$export$2e2bcd8739ae039)(work.title)}/`;
            this.setSubpage(slug, work.title);
        }
        this.sidebarView.configureCurrentYear(this.data.work[itemIndex].year);
    }
}
var $947d90383f4d5760$export$2e2bcd8739ae039 = $947d90383f4d5760$var$RootView;


var $b2b5fe9e0a9bcc22$exports = {};
$b2b5fe9e0a9bcc22$exports = {
    "header": {
        "title": "Mat\xedas Mart\xednez",
        "year": 2023,
        "description": "I\u2019m a fellow human from Chile.",
        "keywords": "designer, developer, Cornershop, Uber, Chile, Mexico, Latin America, startups, UI, UX, product design, portfolio, work, iOS, iPhone, iPad, macOS, JS",
        "preview": "/res/img/preview.jpg"
    },
    "navigation": [
        {
            "title": "Who?",
            "url": "/about/",
            "inline": true
        },
        {
            "title": "Instagram",
            "url": "https://www.instagram.com/matmartinez/"
        },
        {
            "title": "Twitter",
            "url": "https://twitter.com/martinez"
        }
    ],
    "featurette": {
        "title": "Work inquiries?",
        "subtitle": "Mantisa",
        "url": "https://mantisa.com/?ref=matias.me",
        "image": {
            "src": "mantisa.svg",
            "size": [
                46,
                40
            ],
            "alt": "Mantisa"
        }
    },
    "footer": "\xa9 2009-2024\n",
    "work": [
        {
            "title": "Chile Vaccination Card for Apple Wallet",
            "role": "Maker",
            "year": 2022,
            "action": {
                "title": "Add to Wallet",
                "url": "https://pase.pro/"
            },
            "image": {
                "src": "pase-pro.png",
                "size": [
                    405,
                    645
                ],
                "alt": "Apple Watch displaying a chilean vaccination card."
            }
        },
        {
            "title": "Figurative for iPad",
            "role": "Maker",
            "year": 2021,
            "action": {
                "title": "Get",
                "url": "https://figurative.design/"
            },
            "image": {
                "src": "figurative.png",
                "size": [
                    718,
                    572
                ],
                "alt": "iPad Pro with a keyboard case attached displaying Figma."
            }
        },
        {
            "title": "Uber Grocery",
            "role": "Product Design",
            "company": "Cornershop (adquired by Uber)",
            "year": 2020,
            "image": {
                "src": "uber-grocery.png",
                "size": [
                    424,
                    857
                ],
                "alt": "iPhone displaying different grocery stores to pick from."
            },
            "team": [
                "Laura Sandoval",
                "Angela Wen",
                "Angie Kwan",
                "Gonzalo Castillo",
                "Francisco Y\xe1\xf1ez",
                "Francisco Garc\xeda",
                "Osvaldo Mena",
                "Alejandra Fern\xe1ndez",
                "Ricardo Oyarzun",
                "Mat\xedas Mart\xednez"
            ]
        },
        {
            "title": "Design Principles",
            "role": "Manager, Co-Author",
            "company": "Cornershop",
            "year": 2019,
            "image": {
                "src": "cornershop-design-principles.png",
                "size": [
                    480,
                    660
                ],
                "alt": "iPad Pro displaying a design principles website with illustrations."
            },
            "team": [
                "Samuel G\xf3mez",
                "Alegre Gonz\xe1lez",
                "Varsha Ashok",
                "Gonzalo Castillo",
                "Laura Sandoval",
                "Nickole Pizarro",
                "Cristopher Oyarz\xfan",
                "Mat\xedas Mart\xednez"
            ]
        },
        {
            "title": "MMNumberKeyboard",
            "role": "Design, Development",
            "year": 2017,
            "image": {
                "src": "mmnumberkeyboard.png",
                "size": [
                    449,
                    896
                ],
                "alt": "iPhone displaying a simple numeric keyboard on what is seems like a test application."
            },
            "action": {
                "title": "GitHub",
                "url": "https://github.com/matmartinez/MMNumberKeyboard"
            }
        },
        {
            "title": "\u201CTrojan Avocado\u201D",
            "role": "Concept, Crack-Photoshop Job",
            "company": "Cornershop",
            "year": 2017,
            "image": {
                "src": "trojan-avocado.png",
                "size": [
                    612,
                    459
                ],
                "alt": "Framed mythological painting that represents a scene from the Trojan War. Instead of the a wooden horse, there's a giant wooden avocado dragged into the City of Troy."
            },
            "team": [
                "Oskar Hjertonsson",
                "Mat\xedas Mart\xednez"
            ]
        },
        {
            "title": "Cornershop for Web",
            "role": "Product, Design, Development",
            "company": "Cornershop",
            "year": 2016,
            "image": {
                "src": "cornershop-new-web.png",
                "size": [
                    1018,
                    596
                ],
                "alt": "MacBook Pro displaying a website for shopping groceries from Superama."
            },
            "team": [
                "Javiera Vasquez",
                "Francisco Y\xe1\xf1ez",
                "Osvaldo Mena",
                "Oskar Hjertonsson",
                "Daniel Undurraga",
                "Mat\xedas Mart\xednez"
            ]
        },
        {
            "title": "Home",
            "role": "Product, Design, Development",
            "company": "Cornershop",
            "year": 2016,
            "image": {
                "src": "cornershop-landing.png",
                "size": [
                    842,
                    493
                ],
                "alt": "MacBook Air displaying a website with big and bold letters in red, typeset in Avenir Next, that reads \u201CGroceries from your doorstep in one hour\u201D on top of a giant tomato."
            },
            "team": [
                "Oskar Hjertonsson",
                "Daniel Undurraga",
                "Juan Pablo Cuevas",
                "Mat\xedas Mart\xednez"
            ]
        },
        {
            "title": "Shopper for iPhone",
            "role": "Product, Design",
            "company": "Cornershop",
            "year": 2015,
            "image": {
                "src": "cornershop-shopper-ios.png",
                "size": [
                    435,
                    888
                ],
                "alt": "iPhone displaying an app for picking groceries. It shows the customer has requested 2 ripe bananas, and there's different options to mark the product as found, offer a replacement, or give a refund."
            },
            "team": [
                "Cristopher Oyarz\xfan",
                "Francisco Fuentes",
                "Hector Ghinaglia",
                "Mat\xedas Mart\xednez"
            ]
        },
        {
            "title": "Shopper for Android",
            "role": "Product, Design",
            "company": "Cornershop",
            "year": 2015,
            "image": {
                "src": "cornershop-shopper-android.png",
                "size": [
                    429,
                    861
                ],
                "alt": "Google Pixel displaying an app for picking groceries. It shows a barcode scanner that is using the device's camera, currently detecting a barcode framed on a green rectangle."
            },
            "team": [
                "Cristopher Oyarz\xfan",
                "Francisco Fuentes",
                "Hector Ghinaglia",
                "Mat\xedas Mart\xednez"
            ]
        },
        {
            "title": "Shoppers Self-Onboard",
            "role": "Product, Design",
            "company": "Cornershop",
            "year": 2015,
            "image": {
                "src": "cornershop-shopper-welcome.png",
                "size": [
                    429,
                    861
                ],
                "alt": 'Google Pixel displaying a welcome message. It includes the Cornershop logo and a "We Can Do It!" American World War II wartime poster.'
            },
            "team": [
                "Francisco Fuentes",
                "Diego Carey",
                "Mat\xedas Mart\xednez"
            ]
        },
        {
            "title": "Cornershop for iPad",
            "role": "Product, Design, Development",
            "company": "Cornershop",
            "year": 2015,
            "image": {
                "src": "cornershop-ipad.png",
                "size": [
                    480,
                    678
                ],
                "alt": "An iPad displaying the Cornershop app, showing the storefront of a grocery store. It has a list of aisles with colorful background images on the left, and a grid of products for the selected aisle on the right. An image of lemons is being dragged from the grid."
            },
            "team": [
                "Diego Torres",
                "Mat\xedas Mart\xednez"
            ]
        },
        {
            "title": "Cornershop for iPhone",
            "role": "Product, Design, Development",
            "company": "Cornershop",
            "year": 2015,
            "image": {
                "src": "cornershop-iphone.png",
                "size": [
                    436,
                    888
                ],
                "alt": "An iPhone displaying the Cornershop app, showing a pack of bananas. The user interface has lots of white space and buttons are tinted in a shade of red. A toolbar shows that 4 bananas were added into the Cart."
            },
            "team": [
                "Diego Torres",
                "Oskar Hjertonsson",
                "Daniel Undurraga",
                "Chaq Cuevas",
                "Cristopher Oyarz\xfan",
                "Osvaldo Mena",
                "Mat\xedas Mart\xednez"
            ]
        },
        {
            "title": "Seahorse",
            "role": "User Interface Design, Development",
            "year": 2014,
            "image": {
                "src": "seahorse-ios7.png",
                "size": [
                    362,
                    737
                ],
                "alt": 'An iPhone displaying an app with a grid of 4 photos. One of the photos is being flipped in 3D space to reveal another photo. A purple selection shows "Flashback" and text "Two years ago today" below the images.'
            },
            "team": [
                "Diego Torres",
                "Oskar Hjertonsson",
                "Daniel Undurraga",
                "Cristopher Oyarz\xfan",
                "Osvaldo Mena",
                "Mat\xedas Mart\xednez"
            ]
        },
        {
            "title": "Seahorse \u2606 iOS 6",
            "role": "User Interface Design, Development",
            "year": 2013,
            "image": {
                "src": "seahorse-ios6.png",
                "size": [
                    380,
                    799
                ],
                "alt": "An iPhone displaying an app with a grid of 12 photos in a shared album. The user interface is dark and the photos look vibrant. A purple camera button to add more photos can be seen on a toolbar."
            },
            "team": [
                "Diego Torres",
                "Oskar Hjertonsson",
                "Daniel Undurraga",
                "Cristopher Oyarz\xfan",
                "Osvaldo Mena",
                "Mat\xedas Mart\xednez"
            ]
        },
        {
            "title": "Posterama",
            "role": "Maker",
            "year": 2013,
            "image": {
                "src": "posterama.png",
                "size": [
                    843,
                    636
                ],
                "alt": 'An Apple Thunderbolt Display is displaying a dark website in fullscreen. It shows a vintage poster from the film "A Hard Day\'s Night" in Spanish. Another partially visible poster can be seen behind it.'
            }
        },
        {
            "title": "Controls",
            "role": "Maker",
            "year": 2012,
            "image": {
                "src": "controls.png",
                "size": [
                    440,
                    831
                ],
                "alt": "An iPhone 5 is displaying a fullscreen app that resembles a remote control made from aluminum. A directional pad shaped like a ring in black is located at the top. Below it there's a black play and pause black button."
            }
        },
        {
            "title": "Unnamed Music app",
            "role": "Maker",
            "year": 2012,
            "image": {
                "src": "albums.png",
                "size": [
                    790,
                    443
                ],
                "alt": "A MacBook Air is displaying a Music app with Cover Flow and a list of songs. The user interface is themed dark, with a darker shade of aluminum for the window frame."
            }
        },
        {
            "title": "NSFW",
            "role": '<span aria-label="Corrupted pixels" role="img">\u25A3\u25A8\u25A6\u25A4\u25A3</span>',
            "year": 2012,
            "image": {
                "src": "nsfw.png",
                "size": [
                    1024,
                    824
                ],
                "alt": 'A 27-inch iMac is displaying a mysterious website in fullscreen. The screen is mostly empty with the exception of a small pink button in the center that reads "Trust me".'
            },
            "action": {
                "title": "Launch",
                "url": "https://matias.me/nsfw"
            }
        },
        {
            "title": "Written",
            "role": "Maker",
            "year": 2011,
            "image": {
                "src": "written.png",
                "size": [
                    384,
                    745
                ],
                "alt": "An iPhone 4 is displaying a text editing app with an on-screen keyboard. The screen has a suble paper-like brown texture, and the text is being syntax-highlighted with the Markdown markup language."
            }
        },
        {
            "title": "Delivery",
            "role": "Maker",
            "year": 2011,
            "image": {
                "src": "delivery.png",
                "size": [
                    790,
                    464
                ],
                "alt": 'A MacBook Pro is displaying an orange window that reads "Drop source code here". The window has a simple line illustration of two sheets of paper enclosed in dashed line with rounded corners. The Dock shows an icon of a Vespa in the style of Xcode.'
            }
        },
        {
            "title": "Review",
            "role": "Maker",
            "year": 2010,
            "image": {
                "src": "review.png",
                "size": [
                    772,
                    660
                ],
                "alt": 'An iMac is displaying a text editor app with two panes. A sheet made of wood is presented on the main window, despicting two photorealistic dictionaries the user can choose from. The dock shows an icon of an uppercase and lowercase letter "A".'
            }
        },
        {
            "title": "AirMail",
            "role": "Developer, User Interface Design",
            "year": 2009,
            "image": {
                "src": "airmail.png",
                "size": [
                    796,
                    472
                ],
                "alt": "A MacBook is displaying a notification on the upper-right corner of the screen. It has a paper airplane icon. The same airplane icon shape can be seen in the menu bar, highlighted in blue."
            },
            "team": [
                "Angelo Stazzi",
                "Mat\xedas Mart\xednez"
            ]
        }
    ],
    "pages": {
        "/about/": {
            "title": "Who?",
            "body": '<p>Hola! I\'m Mat\xedas. Growing up, I taught myself how to do computer stuff and discovered that I really enjoy making things. That\'s mostly it.</p>\n  \n<p>I was born in Curic\xf3, Chile. I tried my luck and moved to San Francisco, USA because some crazy guys wanted me to build a social app named <a target="_blank" href="https://techcrunch.com/2014/09/04/seahorse-lets-you-collaborate-with-friends-to-build-lasting-photo-and-video-albums-shared-privately/">Seahorse</a> <em>(spoiler: it was a failure)</em>. I went back to Chile and then got lucky starting the grocery app/service  <a target="_blank" href="https://techcrunch.com/2021/06/21/uber-to-become-the-sole-owner-of-grocery-delivery-startup-cornershop/">Cornershop</a>.</p>\n\n<p>I also like playing piano, videogames, and <a target="_blank" href="https://en.wikipedia.org/wiki/Mazda_MX-5">Miatas</a>\u2014all of which I kinda suck at. I once made a <a target="_blank" href="https://knowyourmeme.com/memes/ditto-conga">meme</a> and it went viral.</p>\n\n<p>Feel free to write me \u2014 <a href="mailto:Mat\xedas%20Mart\xednez%20<hello@matias.me>?subject=Hola!" alt="Send an email">hello@matias.me</a> <em>(I do suck too at email, but I really love meeting people)</em>.</p>\n',
            "images": [
                {
                    "src": "computerwelt.jpg",
                    "alt": "Me as a 5 year old."
                },
                {
                    "src": "trucker.jpg",
                    "alt": "Me driving a Mazda Miata (conceptualized)."
                },
                {
                    "src": "long.jpg",
                    "alt": "Me (long version)."
                },
                {
                    "src": "love.jpg",
                    "alt": "My girlfriend and me."
                },
                {
                    "src": "gpoy.jpg",
                    "alt": "Me as me."
                }
            ]
        },
        "/404/": {
            "title": "Page not found",
            "body": "<p>It seems like the page you were looking was moved or decided to take a spontaneous vacation. <i>Guru meditation error #0000404</i>.</p>\n"
        }
    }
};


var $5f0bfce91d95da79$exports = {};
var $72047d80ab1a42aa$exports = {};
$72047d80ab1a42aa$exports = new URL("computerwelt.ff1a5015.jpg", import.meta.url).toString();


var $a1b19fc9c255e559$exports = {};
$a1b19fc9c255e559$exports = new URL("computerwelt.70a15baa.webp", import.meta.url).toString();


var $c8b9d5609605fee1$exports = {};
$c8b9d5609605fee1$exports = new URL("gpoy.40c0d905.jpg", import.meta.url).toString();


var $d62400e52392e968$exports = {};
$d62400e52392e968$exports = new URL("gpoy.6c09d5b5.webp", import.meta.url).toString();


var $7c547fc2ba1a05b1$exports = {};
$7c547fc2ba1a05b1$exports = new URL("long.9e540775.jpg", import.meta.url).toString();


var $d16e81578b590169$exports = {};
$d16e81578b590169$exports = new URL("long.9af40e67.webp", import.meta.url).toString();


var $f5e5bbe3e35c84e3$exports = {};
$f5e5bbe3e35c84e3$exports = new URL("love.560a684f.jpg", import.meta.url).toString();


var $364ffa206a04196f$exports = {};
$364ffa206a04196f$exports = new URL("love.a30d219d.webp", import.meta.url).toString();


var $299430886ca63669$exports = {};
$299430886ca63669$exports = new URL("trucker.b2be2d80.jpg", import.meta.url).toString();


var $0835ee1f70ef058c$exports = {};
$0835ee1f70ef058c$exports = new URL("trucker.86c2adc8.webp", import.meta.url).toString();


var $953f96a02dde8ddd$exports = {};
$953f96a02dde8ddd$exports = new URL("mantisa.705d4652.svg", import.meta.url).toString();


var $3b03d9d9cf6aa3e8$exports = {};
$3b03d9d9cf6aa3e8$exports = new URL("airmail.a9ce0858.png", import.meta.url).toString();


var $7380a85193568939$exports = {};
$7380a85193568939$exports = new URL("airmail.789190ba.webp", import.meta.url).toString();


var $9f249bbefb824fbc$exports = {};
$9f249bbefb824fbc$exports = new URL("albums.89f53e45.png", import.meta.url).toString();


var $87930ec8b192b9dc$exports = {};
$87930ec8b192b9dc$exports = new URL("albums.deb1d967.webp", import.meta.url).toString();


var $3226b0213d43d638$exports = {};
$3226b0213d43d638$exports = new URL("controls.bb5a8133.png", import.meta.url).toString();


var $387f034dad0ce604$exports = {};
$387f034dad0ce604$exports = new URL("controls.cbcf97b1.webp", import.meta.url).toString();


var $58369c48cfb557c9$exports = {};
$58369c48cfb557c9$exports = new URL("cornershop-design-principles.62b0673f.png", import.meta.url).toString();


var $bf3e6d0d8151c758$exports = {};
$bf3e6d0d8151c758$exports = new URL("cornershop-design-principles.1da6c63e.webp", import.meta.url).toString();


var $75da8f42cb67f76c$exports = {};
$75da8f42cb67f76c$exports = new URL("cornershop-ipad.448dc465.png", import.meta.url).toString();


var $34b174b396fd145c$exports = {};
$34b174b396fd145c$exports = new URL("cornershop-ipad.cd5a7796.webp", import.meta.url).toString();


var $31a7b9aab32bad93$exports = {};
$31a7b9aab32bad93$exports = new URL("cornershop-iphone.00b54ee3.png", import.meta.url).toString();


var $978f2e22cdcc566f$exports = {};
$978f2e22cdcc566f$exports = new URL("cornershop-iphone.cd391b81.webp", import.meta.url).toString();


var $82a06564bd7ebc4b$exports = {};
$82a06564bd7ebc4b$exports = new URL("cornershop-landing.bf75d349.png", import.meta.url).toString();


var $1b3b16beb0091f34$exports = {};
$1b3b16beb0091f34$exports = new URL("cornershop-landing.ab064150.webp", import.meta.url).toString();


var $431d35d224583bd8$exports = {};
$431d35d224583bd8$exports = new URL("cornershop-new-web.11b52b92.png", import.meta.url).toString();


var $1597807f45015548$exports = {};
$1597807f45015548$exports = new URL("cornershop-new-web.a201bd93.webp", import.meta.url).toString();


var $6709c0db743d6bc8$exports = {};
$6709c0db743d6bc8$exports = new URL("cornershop-shopper-android.bb6af1c5.png", import.meta.url).toString();


var $191ec6f0045d2ee2$exports = {};
$191ec6f0045d2ee2$exports = new URL("cornershop-shopper-android.4494de11.webp", import.meta.url).toString();


var $d532fd2cc388b05d$exports = {};
$d532fd2cc388b05d$exports = new URL("cornershop-shopper-ios.d8300df0.png", import.meta.url).toString();


var $efcc04f7bc306744$exports = {};
$efcc04f7bc306744$exports = new URL("cornershop-shopper-ios.d4e943eb.webp", import.meta.url).toString();


var $da603de8909bb030$exports = {};
$da603de8909bb030$exports = new URL("cornershop-shopper-welcome.2b479668.png", import.meta.url).toString();


var $0db04f1aadf07296$exports = {};
$0db04f1aadf07296$exports = new URL("cornershop-shopper-welcome.cad18a92.webp", import.meta.url).toString();


var $93578014dc28ebd1$exports = {};
$93578014dc28ebd1$exports = new URL("delivery.eab3b74e.png", import.meta.url).toString();


var $d5d310e4caddcb14$exports = {};
$d5d310e4caddcb14$exports = new URL("delivery.5049ed34.webp", import.meta.url).toString();


var $f5444906b6fd7e48$exports = {};
$f5444906b6fd7e48$exports = new URL("figurative.82f98a82.png", import.meta.url).toString();


var $5b2dafd9e7881383$exports = {};
$5b2dafd9e7881383$exports = new URL("figurative.6ffba798.webp", import.meta.url).toString();


var $3f09c9b1e524f79b$exports = {};
$3f09c9b1e524f79b$exports = new URL("mmnumberkeyboard.86bf2aa7.png", import.meta.url).toString();


var $ba8908d98f0ab0de$exports = {};
$ba8908d98f0ab0de$exports = new URL("mmnumberkeyboard.03c445b6.webp", import.meta.url).toString();


var $b5e7de123d15fd3c$exports = {};
$b5e7de123d15fd3c$exports = new URL("nsfw.f861f684.png", import.meta.url).toString();


var $ccb028c0f2656b71$exports = {};
$ccb028c0f2656b71$exports = new URL("nsfw.c2e75acf.webp", import.meta.url).toString();


var $3b82daa7187d7e0f$exports = {};
$3b82daa7187d7e0f$exports = new URL("pase-pro.da0f177e.png", import.meta.url).toString();


var $2b74548ba486ec50$exports = {};
$2b74548ba486ec50$exports = new URL("pase-pro.7692fa5c.webp", import.meta.url).toString();


var $324ee4a501ea3a1f$exports = {};
$324ee4a501ea3a1f$exports = new URL("posterama.6c2e2313.png", import.meta.url).toString();


var $e84fdfff7e51f1aa$exports = {};
$e84fdfff7e51f1aa$exports = new URL("posterama.49d44a8e.webp", import.meta.url).toString();


var $9e638ae2ececcc3e$exports = {};
$9e638ae2ececcc3e$exports = new URL("review.24e874f5.png", import.meta.url).toString();


var $46c4ddd5c7938f69$exports = {};
$46c4ddd5c7938f69$exports = new URL("review.19aa6bbe.webp", import.meta.url).toString();


var $ea49d229a8ec6457$exports = {};
$ea49d229a8ec6457$exports = new URL("seahorse-ios6.291e25fe.png", import.meta.url).toString();


var $94b8817059ccdf45$exports = {};
$94b8817059ccdf45$exports = new URL("seahorse-ios6.d1698305.webp", import.meta.url).toString();


var $459badec21f43e5a$exports = {};
$459badec21f43e5a$exports = new URL("seahorse-ios7.d2fb26c0.png", import.meta.url).toString();


var $26abb4ee7b4fa64e$exports = {};
$26abb4ee7b4fa64e$exports = new URL("seahorse-ios7.a7a14216.webp", import.meta.url).toString();


var $9106890a6d0c2fa7$exports = {};
$9106890a6d0c2fa7$exports = new URL("trojan-avocado.87b52894.png", import.meta.url).toString();


var $a34fcdfafdc96611$exports = {};
$a34fcdfafdc96611$exports = new URL("trojan-avocado.aa87639f.webp", import.meta.url).toString();


var $253fc0f8dea159be$exports = {};
$253fc0f8dea159be$exports = new URL("uber-grocery.ddec2f17.png", import.meta.url).toString();


var $31b86ac64e3f734e$exports = {};
$31b86ac64e3f734e$exports = new URL("uber-grocery.09c27c5f.webp", import.meta.url).toString();


var $5b3275529c596ddc$exports = {};
$5b3275529c596ddc$exports = new URL("written.8ff0315d.png", import.meta.url).toString();


var $f4e5d6bce6fba813$exports = {};
$f4e5d6bce6fba813$exports = new URL("written.a01101e6.webp", import.meta.url).toString();


$5f0bfce91d95da79$exports = {
    "about": {
        "computerwelt.jpg": $72047d80ab1a42aa$exports,
        "computerwelt.webp": $a1b19fc9c255e559$exports,
        "gpoy.jpg": $c8b9d5609605fee1$exports,
        "gpoy.webp": $d62400e52392e968$exports,
        "long.jpg": $7c547fc2ba1a05b1$exports,
        "long.webp": $d16e81578b590169$exports,
        "love.jpg": $f5e5bbe3e35c84e3$exports,
        "love.webp": $364ffa206a04196f$exports,
        "trucker.jpg": $299430886ca63669$exports,
        "trucker.webp": $0835ee1f70ef058c$exports
    },
    "featurette": {
        "mantisa.svg": $953f96a02dde8ddd$exports
    },
    "work": {
        "airmail.png": $3b03d9d9cf6aa3e8$exports,
        "airmail.webp": $7380a85193568939$exports,
        "albums.png": $9f249bbefb824fbc$exports,
        "albums.webp": $87930ec8b192b9dc$exports,
        "controls.png": $3226b0213d43d638$exports,
        "controls.webp": $387f034dad0ce604$exports,
        "cornershop-design-principles.png": $58369c48cfb557c9$exports,
        "cornershop-design-principles.webp": $bf3e6d0d8151c758$exports,
        "cornershop-ipad.png": $75da8f42cb67f76c$exports,
        "cornershop-ipad.webp": $34b174b396fd145c$exports,
        "cornershop-iphone.png": $31a7b9aab32bad93$exports,
        "cornershop-iphone.webp": $978f2e22cdcc566f$exports,
        "cornershop-landing.png": $82a06564bd7ebc4b$exports,
        "cornershop-landing.webp": $1b3b16beb0091f34$exports,
        "cornershop-new-web.png": $431d35d224583bd8$exports,
        "cornershop-new-web.webp": $1597807f45015548$exports,
        "cornershop-shopper-android.png": $6709c0db743d6bc8$exports,
        "cornershop-shopper-android.webp": $191ec6f0045d2ee2$exports,
        "cornershop-shopper-ios.png": $d532fd2cc388b05d$exports,
        "cornershop-shopper-ios.webp": $efcc04f7bc306744$exports,
        "cornershop-shopper-welcome.png": $da603de8909bb030$exports,
        "cornershop-shopper-welcome.webp": $0db04f1aadf07296$exports,
        "delivery.png": $93578014dc28ebd1$exports,
        "delivery.webp": $d5d310e4caddcb14$exports,
        "figurative.png": $f5444906b6fd7e48$exports,
        "figurative.webp": $5b2dafd9e7881383$exports,
        "mmnumberkeyboard.png": $3f09c9b1e524f79b$exports,
        "mmnumberkeyboard.webp": $ba8908d98f0ab0de$exports,
        "nsfw.png": $b5e7de123d15fd3c$exports,
        "nsfw.webp": $ccb028c0f2656b71$exports,
        "pase-pro.png": $3b82daa7187d7e0f$exports,
        "pase-pro.webp": $2b74548ba486ec50$exports,
        "posterama.png": $324ee4a501ea3a1f$exports,
        "posterama.webp": $e84fdfff7e51f1aa$exports,
        "review.png": $9e638ae2ececcc3e$exports,
        "review.webp": $46c4ddd5c7938f69$exports,
        "seahorse-ios6.png": $ea49d229a8ec6457$exports,
        "seahorse-ios6.webp": $94b8817059ccdf45$exports,
        "seahorse-ios7.png": $459badec21f43e5a$exports,
        "seahorse-ios7.webp": $26abb4ee7b4fa64e$exports,
        "trojan-avocado.png": $9106890a6d0c2fa7$exports,
        "trojan-avocado.webp": $a34fcdfafdc96611$exports,
        "uber-grocery.png": $253fc0f8dea159be$exports,
        "uber-grocery.webp": $31b86ac64e3f734e$exports,
        "written.png": $5b3275529c596ddc$exports,
        "written.webp": $f4e5d6bce6fba813$exports
    }
};


var $2f14a094e3f3511f$exports = {};
var $375c1602cc42e634$exports = {};
$375c1602cc42e634$exports = new URL("airmail.0c6f5ae0.png", import.meta.url).toString();


var $85116e15e198fd53$exports = {};
$85116e15e198fd53$exports = new URL("airmail.082a6059.webp", import.meta.url).toString();


var $737662a1a67ab915$exports = {};
$737662a1a67ab915$exports = new URL("albums.ab76531b.png", import.meta.url).toString();


var $f15e4e25aebf0802$exports = {};
$f15e4e25aebf0802$exports = new URL("albums.7403bd9c.webp", import.meta.url).toString();


var $084f7963511295ef$exports = {};
$084f7963511295ef$exports = new URL("controls.18bc7465.png", import.meta.url).toString();


var $cc1c621dc6c66438$exports = {};
$cc1c621dc6c66438$exports = new URL("controls.659c28b7.webp", import.meta.url).toString();


var $99a38f9c2499d781$exports = {};
$99a38f9c2499d781$exports = new URL("cornershop-design-principles.dd3ce86f.png", import.meta.url).toString();


var $70b22eb2bbffec41$exports = {};
$70b22eb2bbffec41$exports = new URL("cornershop-design-principles.9a2eab89.webp", import.meta.url).toString();


var $d0162e34e4ea852d$exports = {};
$d0162e34e4ea852d$exports = new URL("cornershop-ipad.8cb34050.png", import.meta.url).toString();


var $81b1400c7f3ef001$exports = {};
$81b1400c7f3ef001$exports = new URL("cornershop-ipad.9e65c3b6.webp", import.meta.url).toString();


var $1dc2c9da0eecfe67$exports = {};
$1dc2c9da0eecfe67$exports = new URL("cornershop-iphone.95e25651.png", import.meta.url).toString();


var $ade93c1089b6bd22$exports = {};
$ade93c1089b6bd22$exports = new URL("cornershop-iphone.ddf7478e.webp", import.meta.url).toString();


var $6507196223fd4a1d$exports = {};
$6507196223fd4a1d$exports = new URL("cornershop-landing.8b40f87a.png", import.meta.url).toString();


var $a763c9cea3e5253b$exports = {};
$a763c9cea3e5253b$exports = new URL("cornershop-landing.9b2bead9.webp", import.meta.url).toString();


var $e5cc8d9b2b917e09$exports = {};
$e5cc8d9b2b917e09$exports = new URL("cornershop-new-web.7631c914.png", import.meta.url).toString();


var $2a2bdbf81c6c5353$exports = {};
$2a2bdbf81c6c5353$exports = new URL("cornershop-new-web.5ea86973.webp", import.meta.url).toString();


var $c6b5a4ac19b01edf$exports = {};
$c6b5a4ac19b01edf$exports = new URL("cornershop-shopper-android.23a1bcf5.png", import.meta.url).toString();


var $8cbd9283ed543340$exports = {};
$8cbd9283ed543340$exports = new URL("cornershop-shopper-android.8ac62481.webp", import.meta.url).toString();


var $a219abde1f6f8778$exports = {};
$a219abde1f6f8778$exports = new URL("cornershop-shopper-ios.8c63d30a.png", import.meta.url).toString();


var $30939ee08c8f23c8$exports = {};
$30939ee08c8f23c8$exports = new URL("cornershop-shopper-ios.94a89cdd.webp", import.meta.url).toString();


var $291ebae44821be80$exports = {};
$291ebae44821be80$exports = new URL("cornershop-shopper-welcome.4225ec78.png", import.meta.url).toString();


var $f6ab998ea929d6d8$exports = {};
$f6ab998ea929d6d8$exports = new URL("cornershop-shopper-welcome.f893666c.webp", import.meta.url).toString();


var $ca407bdd784eeec5$exports = {};
$ca407bdd784eeec5$exports = new URL("delivery.ee8aaefd.png", import.meta.url).toString();


var $0e12f8b671c56ed6$exports = {};
$0e12f8b671c56ed6$exports = new URL("delivery.a382aca2.webp", import.meta.url).toString();


var $d1f6801afcb1046b$exports = {};
$d1f6801afcb1046b$exports = new URL("figurative.e483ba6a.png", import.meta.url).toString();


var $7c9412c1a5750f2b$exports = {};
$7c9412c1a5750f2b$exports = new URL("figurative.d25a3795.webp", import.meta.url).toString();


var $72a2be0f6b57b87f$exports = {};
$72a2be0f6b57b87f$exports = new URL("mmnumberkeyboard.c4682d38.png", import.meta.url).toString();


var $a39a16511106e86a$exports = {};
$a39a16511106e86a$exports = new URL("mmnumberkeyboard.6cec1f4f.webp", import.meta.url).toString();


var $d89a72c0125224f4$exports = {};
$d89a72c0125224f4$exports = new URL("nsfw.e9d0667e.png", import.meta.url).toString();


var $31f5bbdb73101e6b$exports = {};
$31f5bbdb73101e6b$exports = new URL("nsfw.2db9f358.webp", import.meta.url).toString();


var $0af7fefe82618bd7$exports = {};
$0af7fefe82618bd7$exports = new URL("pase-pro.ad90369a.png", import.meta.url).toString();


var $ecba4f37e040c4d7$exports = {};
$ecba4f37e040c4d7$exports = new URL("pase-pro.3a6ea199.webp", import.meta.url).toString();


var $0dd358d075bf6a6f$exports = {};
$0dd358d075bf6a6f$exports = new URL("posterama.bfc7ff2d.png", import.meta.url).toString();


var $7118a7efcdef28d0$exports = {};
$7118a7efcdef28d0$exports = new URL("posterama.28cb5dd1.webp", import.meta.url).toString();


var $8e6dc43463b4b24f$exports = {};
$8e6dc43463b4b24f$exports = new URL("review.71ddacde.png", import.meta.url).toString();


var $86fe78ca7a2dc530$exports = {};
$86fe78ca7a2dc530$exports = new URL("review.6d7e61c7.webp", import.meta.url).toString();


var $4d8ea5c64f88c818$exports = {};
$4d8ea5c64f88c818$exports = new URL("seahorse-ios6.9d217b9d.png", import.meta.url).toString();


var $c4ac9719d1190ce5$exports = {};
$c4ac9719d1190ce5$exports = new URL("seahorse-ios6.e27602f7.webp", import.meta.url).toString();


var $f707d866e23af88e$exports = {};
$f707d866e23af88e$exports = new URL("seahorse-ios7.b87dc9cf.png", import.meta.url).toString();


var $2ab6df048e388318$exports = {};
$2ab6df048e388318$exports = new URL("seahorse-ios7.02afc1f2.webp", import.meta.url).toString();


var $9e30d310f68fba38$exports = {};
$9e30d310f68fba38$exports = new URL("trojan-avocado.4eaf3db6.png", import.meta.url).toString();


var $11e6fa4b48ceec5c$exports = {};
$11e6fa4b48ceec5c$exports = new URL("trojan-avocado.59e5a35b.webp", import.meta.url).toString();


var $4dd2ac978e35675d$exports = {};
$4dd2ac978e35675d$exports = new URL("uber-grocery.8d114004.png", import.meta.url).toString();


var $8970e6c8c2132390$exports = {};
$8970e6c8c2132390$exports = new URL("uber-grocery.14bb46f7.webp", import.meta.url).toString();


var $9c843b5726160f0e$exports = {};
$9c843b5726160f0e$exports = new URL("written.9ea1f18e.png", import.meta.url).toString();


var $538b9c9c1bfbc14c$exports = {};
$538b9c9c1bfbc14c$exports = new URL("written.dbcfdc37.webp", import.meta.url).toString();


$2f14a094e3f3511f$exports = {
    "work": {
        "airmail.png": $375c1602cc42e634$exports,
        "airmail.webp": $85116e15e198fd53$exports,
        "albums.png": $737662a1a67ab915$exports,
        "albums.webp": $f15e4e25aebf0802$exports,
        "controls.png": $084f7963511295ef$exports,
        "controls.webp": $cc1c621dc6c66438$exports,
        "cornershop-design-principles.png": $99a38f9c2499d781$exports,
        "cornershop-design-principles.webp": $70b22eb2bbffec41$exports,
        "cornershop-ipad.png": $d0162e34e4ea852d$exports,
        "cornershop-ipad.webp": $81b1400c7f3ef001$exports,
        "cornershop-iphone.png": $1dc2c9da0eecfe67$exports,
        "cornershop-iphone.webp": $ade93c1089b6bd22$exports,
        "cornershop-landing.png": $6507196223fd4a1d$exports,
        "cornershop-landing.webp": $a763c9cea3e5253b$exports,
        "cornershop-new-web.png": $e5cc8d9b2b917e09$exports,
        "cornershop-new-web.webp": $2a2bdbf81c6c5353$exports,
        "cornershop-shopper-android.png": $c6b5a4ac19b01edf$exports,
        "cornershop-shopper-android.webp": $8cbd9283ed543340$exports,
        "cornershop-shopper-ios.png": $a219abde1f6f8778$exports,
        "cornershop-shopper-ios.webp": $30939ee08c8f23c8$exports,
        "cornershop-shopper-welcome.png": $291ebae44821be80$exports,
        "cornershop-shopper-welcome.webp": $f6ab998ea929d6d8$exports,
        "delivery.png": $ca407bdd784eeec5$exports,
        "delivery.webp": $0e12f8b671c56ed6$exports,
        "figurative.png": $d1f6801afcb1046b$exports,
        "figurative.webp": $7c9412c1a5750f2b$exports,
        "mmnumberkeyboard.png": $72a2be0f6b57b87f$exports,
        "mmnumberkeyboard.webp": $a39a16511106e86a$exports,
        "nsfw.png": $d89a72c0125224f4$exports,
        "nsfw.webp": $31f5bbdb73101e6b$exports,
        "pase-pro.png": $0af7fefe82618bd7$exports,
        "pase-pro.webp": $ecba4f37e040c4d7$exports,
        "posterama.png": $0dd358d075bf6a6f$exports,
        "posterama.webp": $7118a7efcdef28d0$exports,
        "review.png": $8e6dc43463b4b24f$exports,
        "review.webp": $86fe78ca7a2dc530$exports,
        "seahorse-ios6.png": $4d8ea5c64f88c818$exports,
        "seahorse-ios6.webp": $c4ac9719d1190ce5$exports,
        "seahorse-ios7.png": $f707d866e23af88e$exports,
        "seahorse-ios7.webp": $2ab6df048e388318$exports,
        "trojan-avocado.png": $9e30d310f68fba38$exports,
        "trojan-avocado.webp": $11e6fa4b48ceec5c$exports,
        "uber-grocery.png": $4dd2ac978e35675d$exports,
        "uber-grocery.webp": $8970e6c8c2132390$exports,
        "written.png": $9c843b5726160f0e$exports,
        "written.webp": $538b9c9c1bfbc14c$exports
    }
};


// 
// MappedImage.js
// portfolio
// 
// Created on 9/12/23
// 
const $b49ca0e1ad6a215d$var$rename = (filename, extension)=>`${filename.substring(0, filename.lastIndexOf("."))}.${extension}`;
class $b49ca0e1ad6a215d$var$MappedImage {
    src;
    webp;
    dark;
    constructor(source, assets, darkAssets){
        this.src = assets[source.src];
        this.webp = assets[$b49ca0e1ad6a215d$var$rename(source.src, "webp")];
        if (darkAssets) this.dark = new $b49ca0e1ad6a215d$var$MappedImage(source, darkAssets);
    }
}
var $b49ca0e1ad6a215d$export$2e2bcd8739ae039 = $b49ca0e1ad6a215d$var$MappedImage;


class $35da740d59af89ba$var$P2023 extends (0, $1553bf3484a166d1$export$2e2bcd8739ae039) {
    documentDidLoad(document1) {
        // Resolve content:
        const mappedContent = [
            // Work:
            {
                images: (0, (/*@__PURE__*/$parcel$interopDefault($b2b5fe9e0a9bcc22$exports))).work.map(($0)=>$0.image),
                key: "work"
            },
            // About page:
            {
                images: (0, (/*@__PURE__*/$parcel$interopDefault($b2b5fe9e0a9bcc22$exports))).pages["/about/"].images,
                key: "about"
            },
            // Featurette:
            (0, (/*@__PURE__*/$parcel$interopDefault($b2b5fe9e0a9bcc22$exports))).featurette ? {
                images: [
                    (0, (/*@__PURE__*/$parcel$interopDefault($b2b5fe9e0a9bcc22$exports))).featurette.image
                ],
                key: "featurette"
            } : undefined
        ].filter((content)=>content);
        for (const { images: images, key: key } of mappedContent){
            const assets = $5f0bfce91d95da79$exports[key];
            const darkAssets = $2f14a094e3f3511f$exports[key];
            if (!assets) throw new Error(`Cannot find assets for key ${key}`);
            images.forEach((target)=>{
                const mapped = new (0, $b49ca0e1ad6a215d$export$2e2bcd8739ae039)(target, assets, darkAssets);
                Object.assign(target, mapped);
            });
        }
        // Create root view:
        const rootView = new (0, $947d90383f4d5760$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($b2b5fe9e0a9bcc22$exports))));
        const workContainer = document1.querySelector(".root");
        workContainer.appendChild(rootView.node);
        // Configure body:
        document1.body.classList.add("timeline-scroll");
        // Listen for color scheme changes:
        const handleColorSchemeChange = ()=>{
            const backgroundColor = getComputedStyle(document1.documentElement).getPropertyValue("--secondary-background-color");
            document1.querySelector("meta[name=theme-color]").setAttribute("content", backgroundColor);
        };
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", handleColorSchemeChange);
        handleColorSchemeChange();
    }
}
window.app = new $35da740d59af89ba$var$P2023(document);


//# sourceMappingURL=index.11e02ecc.js.map
